<template>
  <div class="quotationWrap" ref="quotationWrap">
    <MobileHeader
      v-if="isMobile"
      ref="header"
      :userInfo="userInfo"
    />
    <div class="header flex-between">
      <div class="header-left flex gap12" :class="isMobile ? 'flex-between' : ''">
        <span class="LogoName">Bidding Hall</span>
        <div class="flex gap8" v-if="isMobile">
          <el-switch 
            v-model="isMuted"
            :active-value="false"
            :inactive-value="true"
            @change="toggleSound"></el-switch>
          <span :class="['ft12', !isMuted ? 'soundOn' : 'soundOff']">{{ isMuted ? 'Sound: OFF' : 'Sound: ON' }}</span>
        </div>
      </div>
      <div class="header-right" v-if="!isMobile && orders_info_within_24_hours">
        <p class="gap8" v-if="orders_info_within_24_hours?.count">
          24H Trading Volume
          <span>{{ orders_info_within_24_hours?.count }}</span>
          orders
        </p>
        <p class="gap8" v-if="false">
          Price Range
          <span>${{orders_info_within_24_hours?.min_price}}-${{ orders_info_within_24_hours?.max_price }}</span>
        </p>
      </div>
    </div>
    <div class="pendingWrap theme-switch-card" v-if="isMobile && hasMultipleProducts">
      <div
        v-for="item in productTabs"
        :key="item.type"
        class="theme-item"
        :class="{
          active: activeProductType === item.type
        }"
        @click="changeProduct(item.type)"
      >
        <div class="theme-content column">
          <span>{{ item.label }}</span>
          <span v-if="item.pending" class="ft12">Pending <i>{{ item.pending }}</i></span>
        </div>

        <div class="badge" v-if="activeProductType !== item.type && item.unread > 0">
          New <span>{{ item.unread }}</span>
        </div>

        <div
          v-if="activeProductType === item.type"
          class="arrow"
        />
      </div>
    </div>
    <div class="contentBox flex gap12">
      <div  v-if="!isMobile" class="fixedWrap">
        <div class="userWrap">
          <el-avatar class="avator" :src="userInfo.avatar"></el-avatar>
          <div class="nick boldTitle ft14">{{ userInfo.name }}</div>
          <div class="desc ft12" v-if="false">Balance <span>${{ userInfo.remain_money }}</span></div>
          <div class="operate-btn flex point" @click="goWithdraw">
            <img src="@/assets/wallet_white.svg" alt="">
            Withdraw
          </div>
          <div class="operate-btn btn1 flex" v-if="false">
            <img src="@/assets/support_icon.svg" alt="">
            Support
          </div>
          <div class="operate-btn btn1 flex point" @click="logoOutfun">
            <img src="@/assets/back_icon.svg" alt="">
            Logout
          </div>
          <p v-if="showSupplierRulesEntry" class="ft12 point rulesBox" style="margin-top: 18px;" @click="goWithdraw('first')">Supplier Rules</p>
        </div>
        <div class="pendingWrap soundWrap point">
          <span class="boldTitle">Order Alerts</span>
          <div class="flex gap8">
            <el-switch
              v-model="isMuted"
              :active-value="false"
              :inactive-value="true"
              @change="toggleSound"></el-switch>
            <span :class="['ft12', !isMuted ? 'soundOn' : 'soundOff']">{{ isMuted ? 'Sound: OFF' : 'Sound: ON' }}</span>
          </div>
        </div>
        <div v-if="hasMultipleProducts && pengdingWrapFlag" class="pendingWrap theme-switch-card">
            <div
              v-for="item in productTabs"
              :key="item.type"
              class="theme-item"
              :class="{
                active: activeProductType === item.type
              }"
              @click="changeProduct(item.type)"
            >
              <div class="theme-content column">
                <span>{{ item.label }}</span>
                <span v-if="item.pending" class="ft12">Pending <i>{{ item.pending }}</i></span>
              </div>

              <div class="badge" v-if="activeProductType !== item.type && item.unread > 0">
                New <span>{{ item.unread }}</span>
              </div>
              <div
                v-if="activeProductType === item.type"
                class="arrow"
              />
            </div>
          <div class="ft12 point rulesBox" @click.stop="goWithdraw('brands')">Edit Brands</div>
        </div>
        <div v-if="!hasMultipleProducts && pengdingWrapFlag" class="pendingWrap point" @click="scrollTop">
          <!-- <div v-if="false" class="pendingWrap point" @click="scrollTop"> -->
            <span class="boldTitle">Pending</span>
            <span class="pending-total">{{ activePendingTotal }}</span>
            <span class="ft12 gotop flex " @click="scrollTop" v-if="false">View Order <img src="@/assets/goTop.svg" alt=""></span>
            <div class="ft12 point rulesBox" @click.stop="goWithdraw('brands')">Edit Brands</div>
        </div>
      </div>
      <div class="main" >
        <div class="main-top">
          <div class="top-one flex-between">
            <div class="one-left flex">
              <span class="boldTitle">{{ currentProductLabel }}</span>
            </div>
            <div class="one-right gap8">
              <div class="unit-r">Min: ${{ min_price }}  MAX :${{ max_price }}</div>
              <div class="flex gap12" style="width: 100%;">
                <el-input class="inputWrap main-input" v-model="qupBidPrice">
                  <span slot="prefix" class="input__icon ">$</span>
                </el-input>
                <div class="confirmBidBtn btn" @click="setBidPrice">{{setBidLoading ? 'Loading...' : 'Confirm My Bid'}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="main-bottom" v-if="recentOrdersList?.length > 0 && !isMobile">
          <el-collapse accordion
          v-model="activeName">
            <el-collapse-item name="1">
              <template slot="title">
                <div class="flex-between expandTitle">
                  <div class="boldTitle flex">
                    Completed/Failed Orders (Last 30 min)
                    <span class="num ft12">{{recentOrdersList?.length}}</span>
                  </div>
                   <div class="flex gap8">
                    <span class="expandText">{{ isExpanded ? 'Collapse' : 'Expand' }}</span>
                    <img :class="[isExpanded ? 'rorate180':'']" src="@/assets/expand.svg" alt="">
                   </div>
                </div>
              </template>
              <div class="completed-list">
                <div class="list-item flex-between" v-for="item in recentOrdersList" :key="item.id">
                  <div class="item-left">
                    <el-tooltip class="item" effect="dark" :content="item.title" placement="top-start">
                      <p class="boldTitle">{{ item.title }}</p>
                    </el-tooltip>
                    <div class="bidStatusCur flex">
                      <span>You bid</span>
                      <span class="ft16" style="display:flex;flex:1">${{ item.bidding_price }}</span>
                    </div>
                  </div>
                  <div class="item-right flex">
                    <div class="flex ft12 right-top gap8">
                      <div class="time">{{ item.bid_time }}</div>
                      <div
                        class="ft14"
                        :class="item.status === 'Completed' ? 'success' : 'failed'"
                      >
                        {{ item.status === 'Completed' ? 'Completed' : 'Closed' }}
                      </div>
                    </div>
                    <div class="right-bottom flex gap12">
                      <template v-if="item.status === 'Completed'">
                        <div class="downLoad flex gap8 point" v-if="false" @click="downLoadBid(item)">
                          <img src="@/assets/downLoad_gray.svg" alt="">
                          {{ item.downloadLoading ? 'Loading...' : 'Download' }}
                        </div>
                        <div class="downLoad flex gap8 point" @click="openUpload(item)">
                          <img src="@/assets/upload_grey.svg" alt="">
                          {{ item.downloadLoading ? 'Loading...' : 'Re-upload' }}
                        </div>
                      </template>
                      <div class="boldTitle" v-else>Bid Failed</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-collapse-item>
        </el-collapse>
        </div>
        <div v-if="successful_bidding_order.length > 0" >
          <el-tag type="danger" class="top-notice" style="margin-top: 12px;width: 100%;">
            <div class="flex noticeWrap">
              <span>Violate next rules, no payment：<span class="iden-number">1</span> For {{ currentProductLabel }} upload:</span><span>Keep the leftmost <i>8 digits</i> of the <i>paper file name</i></span>
              <span><span class="iden-number">2</span> Only English reports are accepted.<a v-if="showSupplierRulesEntry && !isIthenticate" href="/rules" target="_blank" class="more-link">And More</a></span>
            </div>
          </el-tag>
          <div class="main-list success-top flex-between" style="border-radius: 0 0 8px 8px;">
            <p class="boldTitle mt12 gap16 successTitle" style="text-align: left;">
              Pending Orders!
              <span class="ft12" style="font-weight: normal;">Max <i>10</i> orders (including pending) · Complete to bid more</span>
            </p>
            <div class="btn btn2 mt12" @click="openUpload(null, $event)">Upload Report</div>
          </div>
        </div>
        <div v-if="successful_bidding_order.length > 0" class="main-list" style="padding-top: 12px;margin-top: 4px;">
          <div class="list-item list-item1" v-for="(item) in successful_bidding_order" :key="item.id">
            <div class="item-left">
              <el-tooltip class="item" effect="dark" :content="item.title" placement="top-start">
                <p class="text-hidden">{{ item.title }}</p>
              </el-tooltip>
            </div>
            <div class="item-right">
              <div class="flex ft12 right-top gap16">
                <img class="listItemImgType"  v-if="item.report_upload_never_expires == '1'" :src="getProductLogo(activeProductType)" alt="">
                <el-tooltip class="item" popper-class="my-tooltip" effect="dark" v-if="item.report_upload_never_expires == '0'"
                  :content="extend_report_max_times > 0 ? 'Cancels if late · Click to extend' : 'Delay not supported'" placement="bottom-end">
                  <div class="time_out_box point center" @click="openMoreTimesModal(item)">
                    <img class="listItemImgType" :src="getProductLogo(activeProductType)" alt="">
                    <!-- <div class="timeInfo ">{{getCountdownText(item) }} left</div> -->
                    <div class="timeInfo" >
                      <template v-if="item._isConfirming">
                        Overdue upload report, currently being recycled
                      </template>
                      <template v-else>
                        {{ getCountdownText(item) }} left
                      </template>
                    </div>
                  </div>
                </el-tooltip>
                <!-- <div
                  class="time_out_box point center"
                  @mouseenter="item.showTip = true"
                  @mouseleave="item.showTip = false"
                  @click="openMoreTimesModal(item)"
                >
                  <div class="timeInfo">
                    {{ getCountdownText(item) }} left
                  </div>
                  <div v-show="item.showTip" class="custom-tooltip">
                    Cancels if late · Click to extend
                    <div class="arrow"></div>
                  </div>
                </div> -->
                <div class="downLoad flex gap8 point" @click="cancelBidHandle(item)"><img src="@/assets/cancel_pending.svg" alt=""/>{{ item.cancelLoading ? 'Loading...' :'Cancel' }}</div>
                <div class="downLoad flex gap8 point" v-if="item.is_downloaded_paper" style="color: #999999;" @click="downLoadBid(item)"><img src="@/assets/downLoad_gray.svg" alt="">{{item.downloadLoading ? 'Loading...':'Download Paper'}}</div>
                <div class="downLoad flex gap8 point" v-else @click="downLoadBid(item)"><img src="@/assets/download_pending.svg" alt="">{{item.downloadLoading ? 'Loading...':'Download Paper'}}</div>
              </div>
            </div>
          </div>

        </div>
        <template>
          <div  v-if="displayList.length > 0" class="main-list mt12">
            <div class="list-item" v-for="item in displayList" :key="item.id">
              <div class="item-left">
                <el-tooltip class="item" effect="dark" :content="item.title" placement="top-start">
                  <p class="boldTitle">{{ item.title }}</p>
                </el-tooltip>
                <div class="bidStatusWait flex"  v-if="orderStatus[item.order_status]=== '1'">
                  <img src="@/assets/bidding.svg" alt="">Bidding in progress, please wait
                </div>
                <div class="bidStatusCur flex" v-if="orderStatus[item.order_status]=== '3' && item.bidders_num>0">
                  <span>Current lowest</span>
                  <span class="ft16" style="display:flex;flex:1">${{ item.min_price }}</span>
                  <span>🔥 {{ item.bidders_num }} bidders</span>
                </div>
                <div class="bidStatusNot flex" v-if="orderStatus[item.order_status]=== '3' && item.bidders_num == 0">
                  <span>No bids yet</span>
                  <span class="ft16" style="display:flex;flex:1">Be the first</span>
                  ⏰ Waiting
                </div>
              </div>
              <div class="item-right">
                <div class="flex ft12 right-top gap8" v-if="orderStatus[item.order_status]!== '3' ">
                  <img class="listItemImgType" :src="getProductLogo(activeProductType)" alt="">
                  <div class="ft12" v-if="false">Results soon</div>
                  <div class="flex gap8" v-if="orderStatus[item.order_status] != '1'"  @click="openMoreTimesModal(item)">
                    <span class="">Cancels if late</span>
                    <span class="desc ">More Time</span>
                    <img src="@/assets/jiantou.svg" alt="">
                  </div>
                  <!-- <div class="timeInfo">{{getCountdownText(item) }} left</div> -->
                  <div class="timeInfo">
                    <template v-if="item._isConfirming">
                       Confirming bidding results, please wait
                    </template>
                    <template v-else>
                      {{ getCountdownText(item) }} left
                    </template>
                  </div>
                </div>
                <!-- <div class="flex ft12 right-top gap8 imgType"  v-if="orderStatus[item.order_status]=== '3' && (item.bidders_num==0 || qupBidPrice < item.min_price)" >
                  <img class="listItemImgType" :src="getProductLogo(activeProductType)" alt="">
                </div> -->

                <div class="flex right-top gap8 imgType" v-if="orderStatus[item.order_status] == '3'">
                  <img class="listItemImgType" :src="getProductLogo(activeProductType)" alt="">
                  <div class="timeInfoText" v-if="item.bidders_num > 0 && item?.bid_countdown_seconds > 0">{{getCountdownText(item) }} left</div>
                </div>
                <div class="right-bottom flex gap12">
                  <p class="boldTitle ft14" v-if="orderStatus[item.order_status]=== '3' && (item.bidders_num==0 || qupBidPrice < item.min_price)"> lowest wins</p>
                  <p class="boldTitle ft14" v-if="orderStatus[item.order_status]=== '1' && !item.min_price_is_current_login_user && item.current_user_quote > item.min_price">Current lowest: <span class="curBid">${{ item.min_price }}</span> · Your bid too high </p>
                  <p class="boldTitle ft14" v-if="orderStatus[item.order_status]=== '3' && qupBidPrice > item.min_price">Current lowest: <span class="curBidPending">${{ item.min_price }}</span> · Your bid too high </p>
                  <p class="boldTitle ft14" v-if="orderStatus[item.order_status]=== '1' && item.min_price_is_current_login_user">You're the lowest bidder at  <span class="curBid">${{ item.min_price }}</span></p>
                  <p class="boldTitle ft14" v-if="orderStatus[item.order_status]=== '1' && !item.min_price_is_current_login_user && item.current_user_quote == item.min_price">Earlier bid exists · Bid under <span class="curBid">${{ item.min_price }}</span> to win </p>
                  <div class="flex gap12">
                    <!-- <div class="downLoad flex gap8 point" v-if="orderStatus[item.order_status]=== '2' && item.is_downloaded_paper"  @click="downLoadBid(item)"><img src="@/assets/downLoad_gray.svg" alt="">{{item.downloadLoading ? 'Loading...':'Download Paper'}}</div> -->
                    <div class="downLoad flex gap8 point" v-if="false"  @click="downLoadBid(item)"><img src="@/assets/downLoad_gray.svg" alt="">{{item.downloadLoading ? 'Loading...':'Download Paper'}}</div>
                    <div class="btn btn3" v-if="orderStatus[item.order_status] == '2'" @click="cancelBid(item)">{{ item.cancelLoading ? 'Loading...' :'Cancel' }}</div>
                    <div class="btn btn1" v-if="orderStatus[item.order_status]=== '2'" @click="downLoadBid(item)">{{item.downloadLoading ? 'Loading...':'Download Paper'}}</div>
                    <!-- <div class="btn btn2" v-if="orderStatus[item.order_status]=== '2' && item.is_downloaded_paper"  @click="openUpload(item)">Upload Report</div> -->
                  </div>
                  <div class="btn btn3" v-if="orderStatus[item.order_status]=== '1'" @click="cancelBid(item)">{{ item.cancelLoading ? 'Loading...' :'Cancel' }}</div>
                  <div class="btn btn4" v-if="orderStatus[item.order_status]=== '3'" @click="openBidModal(item)">{{ item.bidLoading ? 'Loading...' : 'Place Bid' }}</div>
                </div>
              </div>
            </div>
          </div>
          <el-empty v-if="showEmptyState" :image-size="200" description="The order is still on its way. Please wait a moment."></el-empty>
        </template>
        <div class="newOrdersNumBox flex mt12" v-if="bidding_full_after_order_count > 0">
          <span :class="['num', { flash: isFlashing }]">
            {{ bidding_full_after_order_count }}
          </span>
          <div class="flex-start">
            <p style="text-align: left;color: #22285E;">
              <span class="boldTitle ft14">New Orders</span>
              just slipped by you. 
            </p>
            <p class="desc">
              In all martial arts, only speed is unbeatable — the same goes for grabbing orders. Your hand speed determines your earnings.
            </p>
          </div>
        </div>
      </div>
    </div>
    <AdaptiveDialog
      :visible.sync="uploadAndTimeFlag"
      @close="closeUploadDialog"
    >
      <!-- 标题 -->
      <template #title>
        <template v-if="dialogMode === 'upload'">
          <div class="title flex gap12">
            <div class="">
              <template v-if="is_exist_ai_report === '1'">
                Upload Reports ({{ currentProductLabel }})
                <!-- - Max {{ reportFileLimit }} files ({{ maxOrderGrab }} orders) -->
              </template>
              <template v-else>
                Upload 2 reports for a single order ({{ currentProductLabel }})
              </template>
            </div>
            <div class="fileNameTop" v-if="currentItem?.title">
              <div style="text-align: left;" class="fileLabel">{{ currentItem.title }}</div>
            </div>
          </div>
        </template>
        <template v-if="dialogMode === 'moreTime'">
          <div class="title flex gap12">
            <div class="flex gap8">
              <img src="@/assets/time_icon.svg" alt="">
              <span>Request More Time</span>
            </div>
            <p class="flex">
              <span>+15 min each</span>
              <span class="warnTime">{{ currentItem.countDown }}</span>
            </p>
          </div>
        </template>
      </template>
      <!-- 内容 -->
      <template v-if="dialogMode === 'upload'">
        <div v-if="fileList.length == 0" class="column content">
          <div class="hasReport">
            <p class="boldTitle">Has {{ currentProductLabel }} provided an AI detection report?</p>
            <div class="flex gap16 mt12">
              <span :class="[is_exist_ai_report == '1' ? 'active' :'']" @click="switchAiReportMode('1')">Yes</span>
              <span :class="[is_exist_ai_report == '2' ? 'active' :'']" @click="switchAiReportMode('2')">No</span>
            </div>
          </div>
          <div :class="allowBatchUpload ? 'allowUploadBox': 'normalUpload'" v-if="is_exist_ai_report === '1' && !allowBatchDis">
            <el-checkbox v-model="allowBatchUpload" :disabled="allowBatchDis" size="medium" @change="changeAgree">
              Multiple orders upload allowed（Max 10）
            </el-checkbox>
            <p class="ft12" style="color: #989BA1;">If checked: the first 8 digits of each file must match those of the paper.</p>
          </div>
          <el-upload
            v-if="reportFileLimit"
            class="upload-demo"
            drag
            :limit="reportFileLimit"
            :accept="uploadAccept"
            :on-exceed="handleExceed"
            :before-upload="beforeUpload"
            :on-success="handleSuccess"
            :on-change="handleChange"
            :auto-upload="false"
            :show-file-list="false"
            action="#"
            :multiple="true">
            <img class="mt12" src="@/assets/upload_img.svg" alt="">
            <div class="onlyFile ft12" v-if="is_exist_ai_report == '1'">
              <div v-if="!allowBatchUpload" class="el-upload__click ft12 mt12">
                One {{ currentProductLabel }} <span>Similarity Report</span> and one <span>AI detection report</span>
              </div>
              <div v-else class="el-upload__click ft12 mt12">
                <p>Per orde：<span>1 Similarity Report + 1 AI Report</span></p>
                <p style="margin-top: 4px;">Supports multiple orders at once</p>
              </div>
              <div class="el-upload__text ft12 mt12" style="color: #989BA1;">Supports PDF only {{!allowBatchUpload ? '· Max 2 files':'' }}</div>
            </div>
            <div class="fileAnd" v-if="is_exist_ai_report == '2'">
              <div class="el-upload__click ft12 mt12">
                Upload One <span>Similarity Report + Screenshot</span>
              </div>
              <div class="el-upload__text ft12 mt12" style="color: #989BA1;">Upload: 1 PDF + 1 Screenshot (PNG/JPG)</div>
            </div>
          </el-upload>
          <div  v-if="is_exist_ai_report == '2'" class="mt12 example-card">
            <!-- 上半部分 -->
            <div class="top">
              <!-- 左侧文字 -->
              <div class="left">
                <div class="boldTitle">Example screenshots</div>
                <div class="desc">Upload either one</div>
              </div>

              <!-- 右侧图片 -->
              <div class="right">
                <div class="images">
                  <img
                    v-for="(item, index) in images"
                    :key="index"
                    :src="item"
                    class="thumb"
                  />
                </div>

                <div class="enlarge" @click="preview(0)">
                  click to enlarge ▶
                </div>
              </div>
            </div>

            <!-- 底部提示 -->
            <div class="tip">
              <span class="icon">i</span>
              Screenshot must include title and timestamp
            </div>
          </div>
          <div class="column gap12 mt12" v-if="false">
            <p class="boldTitle ft12">Correct Similarity Report Settings</p>
            <div class="flex switchWrap gap12">
              <div class="flex">Exclude quotes <span>off</span></div>
              <div class="flex">Exclude matches <span>off</span></div>
              <div class="flex">Exclude bibliography <span class="active">on</span></div>
            </div>
          </div>
        </div>

        <template v-if="fileList.length > 0">
          <div
            v-if="showTopAction && uploadStatus !== 'error' && errorCount != 0"
            style="margin-bottom: 12px;"
          >
            <div
              class="btn disBtn flex"
              v-if="isUploading || reachLimit"
            >
              <img src="@/assets/jinzhi.svg" alt="">

              <template v-if="isUploading">
                Uploading...
              </template>

              <template v-else>
                {{ isBatchMode ? `Max ${reportFileLimit} files` : 'Max 2 files' }}
              </template>
            </div>
            <el-upload
              v-else
              ref="upload"
              action="#"
              :file-list="fileList"
              :on-exceed="handleExceed"
              :accept="uploadAccept"
              :on-success="handleSuccess"
              :onChange="handleChange"
              :before-upload="beforeUpload"
              :show-file-list="false"
              :multiple="true"
              :auto-upload="false"
            >
              <div class="uploadBtn2" style="width: 100%;">
                <img src="@/assets/upload_icon.svg" alt="">
                Upload More
              </div>
            </el-upload>

          </div>
          
          <!-- 批量上传模式下的分组显示 -->
          <div v-if="isBatchMode && uploadGroups.length > 0" class="uploadGroupsWrap">
            <div v-for="(group, gIndex) in uploadGroups"  :key="gIndex">
              <div v-if="!(group.status == 'success' && !group.visible)" :class="['group-item',(group.files.length !== 2 || group.prefix == 'unknown') ? 'group-item-warn' : '',group.status==='success' ? 'group-item-success':'']">
                <div class="group-header " v-if="uploadStatus != 'idle'">
                  <div class="group-title flex-between">
                    <p class="boldTitle ft16 text-hidden" style="max-width: 380px;">{{ group.prefix }}</p>
                    <span class="group-status" :class="group.status" style="font-weight: 500;">
                      <template v-if="group.status === 'pending'">Waiting</template>
                      <template v-if="group.status === 'uploading'">Uploading...</template>
                      <template v-if="group.status === 'success'">Success</template>
                      <template v-if="group.status === 'error'"> Error</template>
                    </span>
                  </div>
                  <p class="error ft12" v-if="group.status === 'error'"> {{ group.errorMsg || 'if other reason' }}</p>
                </div>
                <div class="group-files" v-else>
                  <div class="file-item flex" v-for="(item, fIndex) in group.files" :key="fIndex">
                    <div class="fileInfo">
                      <div class="flex-between fileName">
                        <div class="normalTitle text-hidden" style="color: #22285E;">{{ item.file.name }}</div>
                        <img src="@/assets/delete.svg" alt="" class="point" @click="removeFile(item.index)" v-if="!isBatchUploading">
                      </div>
                      <div class="group-warning ft12" v-if="group.files.length !== 2 && !isBatchUploading && group.prefix !== 'unknown'" style="color: #F0361D;">
                        Each order needs exactly 2 files (Similarity + AI reports)
                      </div>
                      <div class="group-warning ft12" v-if="group.prefix == 'unknown'" style="color: #F0361D;">
                        File name must keep first 8 digits · Upload failed/No AI report found
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 全部上传成功展示 -->
            <div v-if="uploadStatus == 'success'" class="column gap12">
              <img src="@/assets/upload_all_success.svg" alt="" />
              <p class="boldTitle" style="color: #1CB89C;">{{ uploadGroups.length }} orders uploaded successfully</p>
            </div>
          </div>

          <!-- 普通模式下的文件列表 -->
          <div v-else class="fileListWrap">
            <div class="file-item flex" v-for="(item,index) in fileList" :key="index">
              <img src="@/assets/file_icon.svg" alt="">
              <div class="fileInfo">
                <div class="flex-between fileName">
                  <div class="boldTitle">{{ item.name }}</div>
                  <img src="@/assets/delete.svg" alt="" @click="removeFile(index)">
                </div>
                <div class="flex-between ft12" style="width: 100%;" v-if="false">
                  <span class="size" style="color: #94A3B7;">12.6MB</span>
                  <span v-if="item.status== 0" style="color: #1CB89C;">Success</span>
                  <span v-else class="time flex gap12">⏳ Pending <span style="color: #FB832D;">99%</span></span>
                </div>
              </div>
            </div>
          </div>

          <!-- 批量上传统计 -->
           <div v-if="allowBatchUpload">
            <div v-if="is_exist_ai_report === '1' && uploadGroups.length > 0 && uploadStatus != 'idle'" class="batch-stats flex-end gap16 mt12 ft12">
              <span><i style="color: #1CB89C;">{{ uploadGroups.filter(g => g.status === 'success').length }}</i> success</span>
              <span v-if="uploadGroups.filter(g => g.status === 'error').length > 0"><i style="color: #F0361D;" >{{ uploadGroups.filter(g => g.status === 'error').length }}</i> failed</span>
              <span v-if="uploadGroups.filter(g => g.status === 'pending' || g.status === 'uploading').length > 0"><i style="color: #989BA1;">{{ uploadGroups.filter(g => g.status === 'pending' || g.status === 'uploading').length }}</i>  pending</span>
            </div>
            <div v-if="is_exist_ai_report === '1' && uploadGroups.length > 0 && uploadStatus == 'idle'" class="batch-stats flex-end gap16 mt12 ft12">
              <span><i style="color: #1CB89C;">{{ uploadGroups.length - reduceIncorrectNum }}</i> orders correct</span>
              <!-- <span><i style="color: #1CB89C;">{{ uploadGroups.filter(g => g.status === 'success').length }}</i> orders correct</span> -->
              <!-- <span><i style="color: #F0351C;">{{ uploadGroups.filter(g => g.prefix === 'unknown').length }}</i> orders incorrect</span> -->
              <span><i style="color: #F0351C;">{{reduceIncorrectNum}}</i> orders incorrect</span>
            </div>
          </div>

      
        </template>
      </template>

      <template v-if="dialogMode === 'moreTime'">
        <div class="column content moreTime_content">
          <p class="desc">Use an extension, each adds 15 extra minutes to submit. Max {{ this.extend_report_max_times }} times.</p>
          <div class="useTimes flex-between">
            <span class="left">Remaining extensions</span>
            <div class="right">
              <span
                v-for="index in extend_report_max_times"
                :key="index"
                :class="[currentItem?.extend_report_times >= index ? 'active' : '']"
              ></span>
            </div>
          </div>
        </div>
      </template>

      <!-- footer -->
      <template #footer>
        <template v-if="dialogMode === 'upload'">
          <div class="dialog-footer">
            <el-button @click="handleCancelDialog">Cancel</el-button>
            <template v-if="fileList.length > 0">
                <el-button class="btn4" type="primary" v-if="uploadStatus !== 'error' && errorCount != 0" @click="uploadFile" :disabled="!isUploadValid" >
                  {{confirmLoading ? 'loading':
                  uploadGroups.length - reduceIncorrectNum > 0 ? `Confirm (${ uploadGroups.length - reduceIncorrectNum})` : 'Confirm'
                 }}
                </el-button>
                <el-button
                v-else
                :type="errorCount == 0 ? 'primary' : 'danger'"
                @click="handleReupload"
              >
              {{errorCount == 0 ? 'Upload More' : 'Re-upload'}}
            </el-button>
          </template>
          </div>
          <div>
            <template v-if="!isBatchMode && fileList.length <= 2">
              <el-progress class="progressBox" v-if="uploadStatus !== 'idle'" :show-text="false" :percentage="percentage" :color="progressColor"></el-progress>
              <div class="flex ft12 mt12 gap16 pendProgress" v-if="uploadStatus !== 'idle' && uploadStatus !== 'error'" >⏳ Pending <span>{{ percentage }}%</span></div>
              <div class="errorTip gap8 mt12 flex" v-if="uploadStatus == 'error'">
                <img src="@/assets/fakeWarn.svg" alt="">{{ uploadErrorInfo }} Please re-upload.
              </div>
            </template>
          </div>
        </template>

        <template v-if="dialogMode === 'moreTime'">
          <div class="dialog-footer">
            <el-button @click="backUpload" v-if="canBackToUpload">Back</el-button>
            <el-button @click="closeExtendTime" v-else>Close</el-button>
            <el-button type="primary" @click="handleMoreTime">Request</el-button>
          </div>
        </template>
      </template>
    </AdaptiveDialog>

    <el-dialog
      :visible="bidFlag"
      width="599px"
      class="biddingDialog"
      :show-close="false"
      :lock-scroll="false"
      :append-to-body="true"
      :modal-append-to-body="true"
      @close="closeBidDialog"
      center>
      <div slot="title" class="title flex gap12">
        <div class="flex gap8">
          <span>Bidding</span>
        </div>
        <p class="flex">
          <span>Lowest ${{ currentItem?.min_price }} · Your bid too high. Try below ${{ currentItem?.min_price }} to win.</span>
        </p>
      </div>
      <div class="column content">
        <div class="flex-between" style="width: 300px;margin-bottom: 8px;">
          <p  class="boldTitle ft14">Place your bid</p>
          <span class="desc ft12">This bid applies to all orders</span>
        </div>
        <el-input class="inputWrap" v-model="qupBidPrice" placeholder="">
          <span slot="prefix" class="input__icon">$</span>
          <span class="unit" slot="suffix">Min: ${{ min_price }}  MAX :${{ max_price }}</span>
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bidFlag = false">Cancel</el-button>
        <el-button type="primary" @click="setOrderBid(false)">Bid</el-button>
      </span>
    </el-dialog>

    <AdaptiveDialog
      :visible.sync="actionOrderFlag"
      @close="closeActionDialog"
    >
      <template #title>
        <template v-if="actionMode === 'cancel'">
          <div class="center gap8">
            <img src="@/assets/fakeWarn.svg" alt="">
            Cancel Order
          </div>
        </template>
        <template v-else>English Reports Only</template>
      </template>
      <div v-if="actionMode === 'cancel'" >
        <div class="mt12 mb16">
          Already submitted to {{ currentProductLabel }}? Cancel now = cannot upload report.
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
          <el-form-item prop="cancel_reason" label-width="0">
            <el-input 
              v-model="ruleForm.cancel_reason"
              placeholder="Please provide a reason"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div v-else class="center gap8 mt12 mb16">
        Only <span style="color: #F0361D;">English</span>
        reports are accepted.
      </div>

      <template #footer>
        <template v-if="actionMode === 'cancel'">
          <div class="dialog-footer">
            <el-button @click="keepOrderStatus">Keep Order</el-button>
            <el-button type="danger" @click="cancelBid(currentItem,'success')" >Cancel Anyway</el-button>
          </div>
        </template>
        <template v-else>
          <div class="btn btn4" style="width: 100%;" @click="understand">I Understand</div>
        </template>
      </template>
    </AdaptiveDialog>

    <el-image
      ref="previewImg"
      style="display: none"
      :src="images[0]"
      :preview-src-list="images"
    />
  </div>
</template>

<script>
import { showSuccess, showError, showWarning } from '@/utils/message';
import request from '@/utils/request';
import {get} from '@/utils/request';
import { logoOut, fetchUserProducts, initActiveProduct, applyProductTheme, getProductLogo as resolveProductLogo, getUserInfo as fetchUserInfo, requiresRulesAgreement } from '@/utils/common';
import { ImagePreview } from 'vant';
import MobileHeader from '@/components/MobileHeader.vue';
import AdaptiveDialog from '@/components/AdaptiveDialog.vue';
import sound from '@/utils/sound';
import { requestNotificationPermission, showNewOrderNotification } from '@/utils/orderNotify';
export default {
  name: 'QuotationView',
  components: {
    MobileHeader,
    AdaptiveDialog
  },
  data() {
    return {
      userProducts: [],
      activeProductType: '105',
      orderDataByType: {},
      pendingByType: {},
      unreadByType: {},
      newSaleId: '',
      uploadController: null,
      uploadErrorInfo: '',
      fileList: [],
      isExpanded: false,
      rawList: [], // 原始数据
      displayList: [], // 处理后的列表
      confirmLoading:false,
      setBidLoading: false,      // 全局报价按钮 loading
      bidLoading: false,         // 竞价按钮 loading
      cancelLoading: false,      // 取消竞价按钮 loading
      downloadLoading: false,    // 下载按钮 loading
      uploadLoading: false,      // 上传按钮 loading
      moreTimeLoading: false,    // 申请更多时间按钮 loading
      logoutLoading: false,      // 退出登录按钮 loading
      moreTimeFlag: false,
      isOnlyMoreTime:true,
      uploadFlag:true,
      actionMode:'download',
      actionOrderFlag:false,
      uploadAndTimeFlag:false,
      dialogMode: 'upload', // upload | moreTime
      canBackToUpload: false,
      bidFlag:false,
      qupBidPrice:'',//页面通用报价
      biddList:[
      ],
      percentage:0,
      currentItem:{
        extend_report_times:1,
      },
      activeName: [],
      formData:new FormData(),
      extend_report_max_times:0,
      orders_info_within_24_hours:null,
      biddingOrders:[],
      orderStatus:{
        'bidding completed':'2',//完成
        'pending bid':'3',//竞价中
        'bidding':'1',//带竞价
      },
      userInfo:{},
      bidding_duration:600,
      reporting_duration:600,
      orderListTimer:null,
      pollTimer: null,
      productPollTimer: null,
      productRefreshInFlight: false,
      max_price:10,
      min_price:0.1,
      config:{},
      countdownTimer:null,
      recentOrdersList:[],
      successful_bidding_order:[],
      showPanel:false,
      windowWidth: window.innerWidth, // 存储窗口宽度
      is_exist_ai_report:'1',
      images:[
        require('@/assets/uploadImg1.jpg'),
        require('@/assets/uploadImg2.jpg'),
      ],
      uploadStatus: 'idle', // idle | uploading | success | error
      maxOrderGrab:0,//最大抢单数
      isBiddingLocked:false,//竞价锁状态
      reportFileLimit:0,
      allowBatchUpload:true,//是否允许批量上传
      // 批量上传相关
      uploadGroups: [], // 文件分组
      currentGroupIndex: 0, // 当前上传的组索引
      batchUploadResults: [], // 批量上传结果
      isBatchUploading: false, // 是否正在批量上传
      errorCount:null,//错误文件数
      allowBatchDis:false,//是否禁用批量控制
      bidding_full_after_order_count:0,
      ruleForm: {
        cancel_reason: '',
      },
      rules: {
        cancel_reason: [
          { required: true, message: 'Please provide a reason', trigger: 'blur' },
        ],
      },
      isFlashing:false,//是否闪烁
      isMuted: sound.isMuted(),//是否静音
      pengdingWrapFlag:false
    };
  },
  computed: {
    hasMultipleProducts() {
      return this.userProducts.length > 1
    },
    productTabs() {
      return this.userProducts.map(item => ({
        type: item.type,
        label: item.name,
        theme: item.theme,
        pending: this.pendingByType[item.type] || 0,
        unread: this.unreadByType[item.type] || 0
      }))
    },
    currentProduct() {
      return this.userProducts.find(item => item.type === String(this.activeProductType)) || {}
    },
    activeCheckType() {
      return String(this.activeProductType)
    },
    activePendingTotal() {
      return this.pendingByType[this.activeCheckType] || 0
    },
    isIthenticate() {
      return this.activeCheckType === '36'
    },
    currentProductLabel() {
      return this.currentProduct.name || ''
    },
    showSupplierRulesEntry() {
      return requiresRulesAgreement(this.userProducts)
    },
    isUploading() {
      return this.uploadStatus === 'uploading';
    },
    reachLimit() {
      console.log(this.isBatchMode,'isBatchMode===', this.reportFileLimit,this.fileList.length);
      return this.isBatchMode
        ? this.fileList.length >= this.reportFileLimit
        : this.fileList.length >= 2;
    },
    showTopAction() {
      return !this.isUploading;
    },
    isBatchMode() {
      return this.is_exist_ai_report === '1' && this.allowBatchUpload;
    },
    allCountdownList() {
      return [
        ...(this.displayList || []),
        ...(this.successful_bidding_order || [])
      ]
    },
    progressColor() {
      if (this.uploadStatus === 'error') {
        return '#FF0000';
      }
      return '#5B3DC4';
    },
    uploadAccept() {
      if (this.is_exist_ai_report === '1') {
        return '.pdf';
      }
      if (this.is_exist_ai_report === '2') {
        return '.pdf,.jpg,.jpeg,.png';
      }
      return '';
    },
    isMobile() {
      return this.windowWidth <= 768 || window.innerWidth <= 768;
    },
    showEmptyState() {
      if (this.displayList.length > 0) return false;
      if (!this.userProducts.length) return true;
      return this.userProducts.every(
        item => (this.pendingByType[item.type] || 0) === 0
      );
    },
    reduceIncorrectNum(){
      let num = 0;
      this.uploadGroups.forEach(item=>{
        if(item.prefix === 'unknown'){
          num++
        }else if(item.files.length !== 2 && item.prefix !== 'unknown'){
          num++
        }
      })
      return num;
    },
    isUploadValid() {
      const files = this.fileList.map(f => f.raw || f);
      const pdfFiles = files.filter(f => f.type === 'application/pdf');
      const imgFiles = files.filter(f =>
        ['image/jpeg', 'image/png'].includes(f.type)
      );

      // ✅ AI 报告存在
      if (this.is_exist_ai_report === '1') {
        if (this.isBatchMode) {
          // 批量模式

          if (files.length < 2 || files.length > this.reportFileLimit) return false;
          if (files.length % 2 !== 0) return false;
          if (pdfFiles.length !== files.length) return false;

          if (!this.uploadGroups.length) return false;

          const invalidGroup = this.uploadGroups.find(g => g.files.length !== 2);
          return !invalidGroup;

        } else {
          // 普通模式（2个PDF）

          return (
            files.length === 2 &&
            pdfFiles.length === 2 &&
            imgFiles.length === 0
          );
        }
      }

      // ✅ 无 AI 报告
      if (this.is_exist_ai_report === '2') {
        return (
          files.length === 2 &&
          pdfFiles.length === 1 &&
          imgFiles.length === 1
        );
      }

      return false;
    }
  },
  watch: {
    // async isIthenticate(val) {
      // 不进行停止
      // 停止旧 timer
      // this.stopGlobalCountdown();
      // // 清空本地 countdown 状态
      // [
      //   ...(this.displayList || []),
      //   ...(this.successful_bidding_order || [])
      // ].forEach(item => {
      //   delete item._countdownSeconds;
      //   delete item._biddingTriggered;
      //   delete item._reportingTriggered;
      // });
      // // 重新请求最新数据
      // await this.getOrdersList();
      // // 非 ithenticate 才开启 countdown
      // if (!val) {
      //   this.startGlobalCountdown();
      // }
    // }
  },
  async mounted(){
    this.userProducts = await fetchUserProducts({ force: true })
    this.activeProductType = initActiveProduct(this.userProducts) || this.userProducts[0]?.type || '105'
    this.initUnreadCounts()
    this.pengdingWrapFlag = true
    window.addEventListener('resize', this.handleResize)
    if (localStorage.getItem('userInfo') !== null) {
      let parsed = {}
      try {
        parsed = JSON.parse(localStorage.getItem('userInfo'))
      } catch {
        parsed = {}
      }
      if (parsed.name || parsed.uid || parsed.id) {
        this.$nextTick(() => {
          this.userInfo = parsed
        })
      } else {
        await this.getUserInfo()
      }
    } else {
      await this.getUserInfo()
    }
    this.getQuotation()

    const requestList = this.userProducts.map(item =>
      this.getOrdersList(false, item.type)
    )

    await Promise.allSettled(requestList)
    this.applyCurrentProductOrders()
    this.getRecentOrdersList()
    this.startPolling()
    this.startProductPolling()
    this.setupAudioUnlock()
    this.setupVisibilityRefresh()
  },
  methods: {
    initUnreadCounts() {
      this.userProducts.forEach(item => {
        this.$set(
          this.unreadByType,
          item.type,
          Number(localStorage.getItem(`unread_count_${item.type}`) || 0)
        )
      })
    },
    getProductLogo(type) {
      return resolveProductLogo(type || this.activeProductType)
    },
    getOrderStorageKeys(type) {
      const productType = String(type)
      return {
        saleKey: `newSaleId_${productType}`,
        readKey: `readSaleId_${productType}`,
        countKey: `unread_count_${productType}`
      }
    },
    // 提取新消息相关
    checkNewOrder(data, type) {
      const pendingList = data?.pending_bid_order || [];
      const productType = String(type)
      const { saleKey, readKey, countKey } = this.getOrderStorageKeys(productType)

      if (!pendingList.length) {
        localStorage.setItem(countKey, 0);
        this.$set(this.unreadByType, productType, 0)
        return;
      }

      const latestSaleId =
        pendingList[pendingList.length - 1].sale_id;

      let oldSaleId = localStorage.getItem(saleKey);
      let readSaleId = localStorage.getItem(readKey);

      // 兼容旧数据：已读标记沿用之前的 newSaleId
      if (!readSaleId && oldSaleId) {
        readSaleId = oldSaleId;
        localStorage.setItem(readKey, readSaleId);
      }

      // 铃声：首次初始化
      if (!oldSaleId && latestSaleId) {
        localStorage.setItem(saleKey, latestSaleId);
        if (!readSaleId) {
          localStorage.setItem(readKey, latestSaleId);
        }
        return;
      }

      // 角标：首次初始化已读位置
      if (!readSaleId && latestSaleId) {
        localStorage.setItem(readKey, latestSaleId);
        readSaleId = latestSaleId;
      }

      const hasNewOrder =
        oldSaleId &&
        latestSaleId &&
        latestSaleId !== oldSaleId &&
        Number(latestSaleId) > Number(oldSaleId);

      // 角标数量：基于「已读」标记，与铃声 newSaleId 独立
      const unreadCount = pendingList.filter(
        item => Number(item.sale_id) > Number(readSaleId)
      ).length;

      localStorage.setItem(countKey, unreadCount);
      this.$set(this.unreadByType, productType, unreadCount)

      if (hasNewOrder) {
        const alertKey = `${type}_${latestSaleId}`;
        if (!this._pendingAlerts) this._pendingAlerts = new Set();
        if (this._pendingAlerts.has(alertKey)) return;

        this._pendingAlerts.add(alertKey);
        // 立即标记已处理，防止轮询/visibility 并发重复响铃
        localStorage.setItem(saleKey, latestSaleId);

        this.alertNewOrder(type, unreadCount).then((alerted) => {
          this._pendingAlerts.delete(alertKey);
          if (!alerted) {
            localStorage.setItem(saleKey, oldSaleId);
          }
        });
      }
      },
    markProductAsRead(checkType) {
      const productType = String(checkType)
      const { readKey, countKey, saleKey } = this.getOrderStorageKeys(productType)
      const data = this.orderDataByType[productType]
      const pendingList = data?.pending_bid_order || [];
      const latestSaleId = pendingList.length
        ? pendingList[pendingList.length - 1].sale_id
        : null;
      const idToMark = latestSaleId || localStorage.getItem(saleKey);

      if (idToMark) {
        localStorage.setItem(readKey, idToMark);
      }

      localStorage.setItem(countKey, 0);
      this.$set(this.unreadByType, productType, 0)
    },
    async alertNewOrder(type, newCount) {
      if (sound.isMuted()) return true;

      if (document.hidden) {
        // 后台：只尝试 playForce，失败则系统通知，不再 play 避免双响
        const played = await sound.playForce(type);
        if (played) return true;
        return showNewOrderNotification(type, newCount);
      }

      return sound.play(type);
    },
    stopGlobalCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
    changeProduct(productType) {
      productType = String(productType)
      this.activeProductType = productType

      const product = this.userProducts.find(item => item.type === productType)
      applyProductTheme(product?.theme)
      localStorage.setItem('activeProductType', productType)
      localStorage.setItem('active_order_type', productType)

      this.markProductAsRead(productType)

      this.displayList = [];
      this.successful_bidding_order = [];
      this.biddingOrders = [];
      this.recentOrdersList = [];
      this.orders_info_within_24_hours = null;
      this.bidding_full_after_order_count = 0;
      this.qupBidPrice = '';

      this.getOrdersList(false, productType)
        .then(() => {
          this.applyCurrentProductOrders();
        });

      this.getQuotation();
      this.getRecentOrdersList();
    },
    setupAudioUnlock() {
      this._unlockAudio = () => {
        sound.unlock().then((unlocked) => {
          console.log(unlocked ? '🔓 音频已解锁' : '🔒 音频未解锁，请再次点击');
        });
        requestNotificationPermission();
      };

      ['click', 'touchstart', 'keydown'].forEach((evt) => {
        document.addEventListener(evt, this._unlockAudio, { passive: true });
      });
    },
    setupVisibilityRefresh() {
      this._onVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
          sound.unlock().then((unlocked) => {
            console.log(unlocked ? '🔓 页面恢复可见，音频已解锁' : '🔒 页面恢复可见，音频未解锁');
          });
        } else {
          // 切走前立即拉一次，减少后台节流导致的漏单
          this.refreshOrders();
        }
        if (document.visibilityState === 'visible') {
          this.refreshUserProducts()
          this.refreshOrders();
        }
      };

      document.addEventListener('visibilitychange', this._onVisibilityChange);
    },
    async refreshUserProducts() {
      if (this.productRefreshInFlight) return
      this.productRefreshInFlight = true

      const prevTypes = this.userProducts.map(item => item.type)
      const prevActive = String(this.activeProductType)

      try {
        const products = await fetchUserProducts({ force: true })
        this.userProducts = products

        products.forEach(item => {
          if (!Object.prototype.hasOwnProperty.call(this.unreadByType, item.type)) {
            this.$set(
              this.unreadByType,
              item.type,
              Number(localStorage.getItem(`unread_count_${item.type}`) || 0)
            )
          }
        })

        const newTypes = products.map(item => item.type)
        const addedTypes = newTypes.filter(type => !prevTypes.includes(type))

        if (addedTypes.length) {
          await Promise.allSettled(
            addedTypes.map(type => this.getOrdersList(true, type))
          )
        }

        if (products.length && !newTypes.includes(prevActive)) {
          const nextType = initActiveProduct(products) || products[0]?.type
          if (nextType) {
            this.changeProduct(nextType)
            return
          }
        }

        this.applyCurrentProductOrders()
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          console.log('refresh user products failed', err?.info || err)
        }
      } finally {
        this.productRefreshInFlight = false
      }
    },
    async refreshOrders() {
      if (!this.userProducts.length) return

      const requestList = this.userProducts.map(item =>
        this.getOrdersList(true, item.type)
      )

      await Promise.allSettled(requestList)
      this.applyCurrentProductOrders()
    },
    playNoticeSound() {
      if (sound.isMuted()) return;
      sound.play().then((played) => {
        if (!played && !sound.isUnlocked()) {
          console.log('🔒 未解锁，等待用户交互...');
        }
      });
    },
    toggleSound() {
      this.isMuted = sound.toggle();
    },
    triggerFlash() {
      this.isFlashing = false;

      // 强制下一帧再加 class（关键）
      this.$nextTick(() => {
        this.isFlashing = true;

        // 动画结束后移除，方便下次触发
        setTimeout(() => {
          this.isFlashing = false;
        }, 500);
      });
    },
    changeAgree() {
      // if(this.rulesAgreed) {
      //   this.allowBatchUpload = true
      //   return
      // }
    },
    downloadHandle(item){
      this.actionMode = 'download';
      this.currentItem = item;
      if(item.is_downloaded_paper){
        this.understand(item)
      }else{
        this.actionOrderFlag =true;
      }
    },
    understand(){
      this.downLoadBid(this.currentItem)
      this.actionOrderFlag = false;
    },
    handleCancelDialog() {
      if (this.uploadController) {
        this.uploadController.abort();
      }
      this.uploadStatus = 'idle';   // ⭐ 关键：隐藏进度条
      this.allowBatchUpload = true;
      this.percentage = 0;
      this.fileList = [];
      this.formData = new FormData();
      this.confirmLoading = false;
      this.uploadAndTimeFlag = false;
      this.is_exist_ai_report = '1';
    },
    handleExceed() {
      const maxFiles = this.is_exist_ai_report === '1' ? this.reportFileLimit : 2;
      showWarning(`You can only upload a maximum of ${maxFiles} files`);
    },
    handleReupload() {
      this.fileList = [];
      this.formData = new FormData();
      this.uploadStatus = 'idle';
      this.percentage = 0;
      // 重置批量上传状态
      this.uploadGroups = [];
      this.currentGroupIndex = 0;
      this.batchUploadResults = [];
      this.isBatchUploading = false;
      if(this.errorCount == 0){
        this.uploadAndTimeFlag = false;
        this.errorCount = null;
      }
    },
    beforeUpload(file) {
      const isPDF = file.type === 'application/pdf';
      const isImg = ['image/jpeg', 'image/png'].includes(file.type);

      const currentFiles = this.fileList.map(f => f.raw);
      const nextFiles = [...currentFiles, file];

      const pdfCount = nextFiles.filter(f => f.type === 'application/pdf').length;
      const imgCount = nextFiles.filter(f =>
        ['image/jpeg', 'image/png'].includes(f.type)
      ).length;

      if (this.is_exist_ai_report === '1') {
        // 未允许批量上传时，最多2个文件
        if (nextFiles.length > 2 && !this.allowBatchUpload) {
          showError('Max 2 files');
          return false;
        }
        // 批量上传模式：最多10个PDF文件
        if (!isPDF) {
          showError('Only PDF allowed');
          return false;
        }
        if (nextFiles.length > this.reportFileLimit) {
          showError(`Max ${this.reportFileLimit} files`);
          return false;
        }
      }

      if (this.is_exist_ai_report === '2') {
        // 1 PDF + 1 图片
        if (!(isPDF || isImg)) {
          showError('Only PDF or Image');
          return false;
        }
        if (pdfCount > 1 || imgCount > 1 || nextFiles.length > 2) {
          showError('Only 1 PDF + 1 Image');
          return false;
        }
      }

      return true; // ✅ 允许加入
    },
    preview(index) {
      if (this.isMobile) {
        // 📱 移动端：vant 预览
        ImagePreview({
          images: this.images,
          startPosition: index,
          zIndex:9999
        });
      } else {
        // 💻 PC：手动触发 el-image 预览
        this.$refs.previewImg.showViewer = true;
      }
    },
    scrollTop(){
      const container = this.$refs.quotationWrap;
      if (container) {
        container.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth
    },
    openPanel() {
      this.showPanel = true;
    },
    closePanel() {
      this.showPanel = false;
    },
    closeUploadDialog() {
      this.uploadAndTimeFlag = false
      this.uploadStatus = 'idle';
      this.percentage = 0;
      this.canBackToUpload = false
      this.fileList = []
      this.formData = new FormData()
      this.percentage = 0
      this.confirmLoading = false;
      this.is_exist_ai_report = '1';
      // 重置批量上传状态
      this.uploadGroups = [];
      this.currentGroupIndex = 0;
      this.batchUploadResults = [];
      this.isBatchUploading = false;
    },
    switchAiReportMode(mode) {
      // 如果模式相同，不做处理
      if (this.is_exist_ai_report === mode) return;

      this.is_exist_ai_report = mode;
      // 设置文件限制
      this.reportFileLimit = mode === '1' ? 10 : 2;
      // 清空已选文件
      this.fileList = [];
      this.formData = new FormData();
      this.uploadGroups = [];
      if (!this.allowBatchUpload) {
        this.uploadGroups = [];
      }
      this.batchUploadResults = [];
    },
    closeActionDialog(){
      this.actionOrderFlag = false;
    },

    closeBidDialog() {
      this.bidFlag = false;
    },

    openUpload(item, e) {
      e?.preventDefault()
      if (item ) {
        // 第一个参数是 item 对象
        this.currentItem = item || null;
        // 禁用批量上传
        this.allowBatchDis = true;
        this.allowBatchUpload = false;
      } else {
        // 第一个参数是事件对象，说明没有传递 item
        this.currentItem = item || null;
        // 允许批量上传
        this.allowBatchUpload = true;
        this.allowBatchDis = false;
      }

      this.dialogMode = 'upload'
      this.uploadAndTimeFlag = true
    },

    openMoreTimesModal(item, e) {
      e?.preventDefault()
      if (this.extend_report_max_times == 0) {
        return
      }
      if (item.extend_report_times >= this.extend_report_max_times) {
        showError(`Max ${this.extend_report_max_times} times!`)
        return
      }

      this.currentItem = item;
      this.dialogMode = 'moreTime';
      this.canBackToUpload = false;
      this.uploadAndTimeFlag = true;
    },
    async getBidResultWithRetry(item) {
      if (item._bidPolling) return;
      item._bidPolling = true;

      // ✅ 开始轮询 → 打标记（用于UI展示）
      this.$set(item, '_isConfirming', true);

      const maxRetry = 10;
      let attempt = 0;
      const sleep = (ms) => new Promise(r => setTimeout(r, ms));

      try {
        while (attempt < maxRetry) {
          const res = await request.post('/api/ajax_get_bid_result', {
            sale_id: item.sale_id,
            order_id: item.order_id,
          });

          if (res.status) {
            this.getRenderOrderList(res, false);
            return;
          }

          attempt++;

          if (attempt >= maxRetry) {
            const retryRes = await request.post('/api/ajax_get_bid_result_retry', {
              sale_id: item.sale_id,
              order_id: item.order_id,
            });

            if (retryRes.status) {
              this.getRenderOrderList(retryRes, false);
            }
            return;
          }

          await sleep(1000);
        }
      } finally {
        item._bidPolling = false;
      }
    },
    getRecentOrdersList(){
      request.post('/api/ajax_get_recent_orders',{
      }).then(res => {
        if(res.status){
          this.recentOrdersList = res.data;
        }else{
          showError(res.info);
        }
      })
    },
    // getTimeoutResult(item){
    //   request.post('/api/ajax_rebidding_upon_timeout',{
    //     sale_id:item.sale_id,
    //     order_id:item.order_id,
    //   }).then(res => {
    //     this.getRenderOrderList(res,false);
    //   })
    // },
    // startPolling() {
    //   if (this.pollTimer) {
    //     clearInterval(this.pollTimer)
    //   }

    //   this.pollTimer = setInterval(async () => {

    //     await Promise.all([
    //       this.getOrdersList(true),
    //       this.has_ithenticate
    //         ? this.getOrdersList(true, '36')
    //         : Promise.resolve()
    //     ]);

    //     this.applyCurrentProductOrders();

    //   }, 3000)
    //   // }, 30000)
    // },
    startPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
      }

      this.pollTimer = setInterval(async () => {
        if (!this.userProducts.length) return

        const requestList = this.userProducts.map(item =>
          this.getOrdersList(true, item.type)
        )

        await Promise.all(requestList);
        this.applyCurrentProductOrders();

      // }, 3000)

      }, 30000)
      },

    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    },
    startProductPolling() {
      if (this.productPollTimer) {
        clearInterval(this.productPollTimer)
      }
      this.productPollTimer = setInterval(() => {
        this.refreshUserProducts()
      }, 3 * 20 * 1000)
    },
    stopProductPolling() {
      if (this.productPollTimer) {
        clearInterval(this.productPollTimer)
        this.productPollTimer = null
      }
    },
  getOrdersList(isPolling = false, checkType = '') {
    const params = {};
    const productType = String(checkType || this.activeCheckType)
    params.check_type = productType;
    return request.post('/api/ajax_get_orders', params)
      .then(res => {

        if (!res.status) {
          // 仅登录失效时停止轮询，其他错误下次继续重试
          if (res.info === 'Login required') {
            this.stopPolling();
          } else {
            showError(res.info);
          }
          return Promise.reject(res);
        }
        this.$set(this.orderDataByType, productType, res.data)
        this.syncPendingCountForProduct(productType, res.data)
        this.checkNewOrder(
          res.data,
          productType
        );
        // 非轮询时才更新当前展示
        if (!isPolling) {
          this.applyCurrentProductOrders();
        }

        return res;

      }).catch(err => {
        console.log('订单请求失败', productType, err);
        return {
          status: false
        };
      });
    },
    applyCurrentProductOrders() {
      const data = this.orderDataByType[this.activeCheckType]
      if (!data) return;

      this.getRenderOrderList(
        data,
        this.activeCheckType
      );
    },
    syncPendingCountForProduct(productType, data) {
      if (!data) return
      const type = String(productType)
      const total =
        (data.bidding_order || []).length +
        (data.successful_bidding_order || []).length
      this.$set(this.pendingByType, type, total)
    },
    getRenderOrderList(res, checkType = '') {
      const productType = String(checkType || this.activeCheckType)
      const config = res?.config || {};
      const newCount = res?.bidding_full_after_order_count || 0;
      this.min_price = config?.min_price;
      this.max_price = config?.max_price;
      this.extend_report_max_times = config?.extend_report_max_times;
      this.maxOrderGrab = parseInt(config?.max_order_grab || 0);
      this.reportFileLimit = this.maxOrderGrab * 2;
      this.biddingOrders = res?.bidding_order || [];
      const pending_bid_order = res?.pending_bid_order || [];
      this.successful_bidding_order =
        res?.successful_bidding_order || [];
      this.orders_info_within_24_hours =
        res?.orders_info_within_24_hours || [];
      this.config = config;

      this.syncPendingCountForProduct(productType, res)

      let newBiddList = [
        ...this.biddingOrders,
        ...pending_bid_order
      ];

      const currentPendingTotal = this.pendingByType[productType] || 0;

      if (currentPendingTotal >= this.maxOrderGrab) {

        newBiddList = [...this.biddingOrders];

        if (
          newCount > 0 &&
          newCount !== this.bidding_full_after_order_count
        ) {
          this.triggerFlash();
        }

        this.bidding_full_after_order_count = newCount;
      } else {
        this.bidding_full_after_order_count = 0;
      }
      this.displayList = newBiddList.map(item => {
        const mapped = {
          ...item,
          _isConfirming: false,
          _biddingTriggered: false,
          _bidPolling: false
        };
        this.initItemCountdown(mapped);
        return mapped;
      });
      this.successful_bidding_order = (this.successful_bidding_order || []).map(item => {
        const mapped = { ...item };
        this.initItemCountdown(mapped);
        return mapped;
      });
      this.startGlobalCountdown();
    },
    getItemCountdownSeconds(item) {
      const toNonNegativeSeconds = (value) => {
        const n = parseInt(value, 10);
        return Math.max(0, Number.isFinite(n) ? n : 0);
      };
      if (item.order_status == 'pending bid' || item.order_status == 'bidding') {
        return toNonNegativeSeconds(item.bid_countdown_seconds);
      }
      if (item.order_status == 'bidding completed') {
        return toNonNegativeSeconds(item.report_countdown_seconds);
      }
      return 0;
    },
    initItemCountdown(item) {
      const seconds = this.getItemCountdownSeconds(item);
      if (seconds > 0) {
        item._countdownDeadline = Date.now() + seconds * 1000;
      } else {
        item._countdownDeadline = 0;
      }
      delete item._countdownSeconds;
    },
    getRemainingCountdown(item) {
      if (item._countdownDeadline > 0) {
        return Math.max(0, Math.floor((item._countdownDeadline - Date.now()) / 1000));
      }
      return this.getItemCountdownSeconds(item);
    },
    startGlobalCountdown() {
      //ithenticate 不需要倒计时逻辑
      // if (this.isIthenticate) {
      //   return;
      // }
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      this.countdownTimer = setInterval(() => {

        // ✅ 合并两个列表参与倒计时
        const allList = [
          ...(this.displayList || []),
          ...(this.successful_bidding_order || [])
        ];

        let needUpdate = false;

        allList.forEach(item => {
          const serverSeconds = this.getItemCountdownSeconds(item);

          if (!item._countdownDeadline) {
            if (serverSeconds <= 0) {
              if (item._countdownSeconds !== 0) {
                this.$set(item, '_countdownSeconds', 0);
                needUpdate = true;
              }
              return;
            }
            this.initItemCountdown(item);
            needUpdate = true;
          }

          const remaining = this.getRemainingCountdown(item);

          if (remaining !== item._countdownSeconds) {
            this.$set(item, '_countdownSeconds', remaining);
            needUpdate = true;
          }

          if (item._countdownDeadline > 0 && remaining === 0) {

                if (item.order_status == 'bidding completed') {

                  if (item._reportingTriggered) return;
                  item._reportingTriggered = true;

                  this.executeWithRetry({
                    item,
                    pollingKey: '_reportPolling',
                    requestFn: () => request.post('/api/ajax_rebidding_upon_timeout', {
                      sale_id: item.sale_id,
                      order_id: item.order_id,
                    }),
                    retryFn: () => request.post('/api/ajax_rebidding_upon_timeout_retry', {
                      sale_id: item.sale_id,
                      order_id: item.order_id,
                    }),
                    onSuccess: (res) => this.updateCurrentProductOrderData(res)
                  });
                } else if (item.order_status == 'bidding') {

                  if (item._biddingTriggered) return;
                  item._biddingTriggered = true;

                  this.executeWithRetry({
                    item,
                    pollingKey: '_bidPolling',
                    requestFn: () => request.post('/api/ajax_get_bid_result', {
                      sale_id: item.sale_id,
                      order_id: item.order_id,
                    }),
                    retryFn: () => request.post('/api/ajax_get_bid_result_retry', {
                      sale_id: item.sale_id,
                      order_id: item.order_id,
                    }),
                    onSuccess: (res) => this.updateCurrentProductOrderData(res)
                  });
                }
          }
        });
        if (needUpdate) {
          this.displayList = [...this.displayList];
          this.successful_bidding_order = this.successful_bidding_order.map(item=>{
            return {
              ...item,
              showTip:false
            }
          });
        }
      }, 1000);
    },
    updateCurrentProductOrderData(res) {
      this.$set(this.orderDataByType, this.activeCheckType, res.data)
      this.applyCurrentProductOrders();
    },
    async executeWithRetry({
      item,
      requestFn,        // 主请求
      retryFn,          // 最终 retry 请求
      onSuccess,        // 成功回调
      maxRetry = 10,
      delay = 1000,
      pollingKey,       // 防并发 key（如 _bidPolling）
      uiKey = '_isConfirming' // UI 状态 key
    }) {

      // ✅ 防并发
      if (item[pollingKey]) return;
      this.$set(item, pollingKey, true);

      // ✅ UI 状态
      this.$set(item, uiKey, true);

      let attempt = 0;
      const sleep = (ms) => new Promise(r => setTimeout(r, ms));

      try {
        while (attempt < maxRetry) {
          const res = await requestFn();

          if (res?.status) {
            onSuccess && onSuccess(res);
            return;
          }

          attempt++;

          if (attempt >= maxRetry) {
            const retryRes = await retryFn();

            if (retryRes?.status) {
              onSuccess && onSuccess(retryRes);
            } else {
              showError(retryRes?.info || 'Retry failed');
            }
            return;
          }

          await sleep(delay);
        }
      } catch (err) {
        // ❗异常也走 retry
        try {
          const retryRes = await retryFn();

          if (retryRes?.status) {
            onSuccess && onSuccess(retryRes);
          } else {
            showError(retryRes?.info || 'Retry failed');
          }
        } catch (e) {
          showError(e.message || 'Retry request failed');
        }
      } finally {
        item[pollingKey] = false;
        // ❗UI 状态不手动关（等列表刷新）
      }
    },

    getCountdownText(item) {
      const displaySeconds = Math.max(0, this.getRemainingCountdown(item));
      item._countdownSeconds = displaySeconds;
      const mins = Math.floor(displaySeconds / 60);
      const secs = displaySeconds % 60;
      item.countDown = `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    },

    async getUserInfo(){
      try {
        this.userInfo = await fetchUserInfo()
      } catch (err) {
        showError(err?.info || err)
      }
    },
    getQuotation(){
      return request.post('/api/ajax_get_quotation', {}).then(res => {
        if(res.status){
          this.qupBidPrice = res.data.quotation;
        }else{
          showError(res.info);
        }
      }).catch(err=>{
        showError(err);
      })
    },
    setBidPrice(){
      this.setBidLoading = true;
      const params =  {
        price:this.qupBidPrice,
      }
      request.post('/api/ajax_set_quotation',params).then(res=>{
        if(res.status){
          this.setBidLoading = false;
          this.getOrdersList(
            false,
            this.activeCheckType
          ).then(() => {
            this.applyCurrentProductOrders();
          });

          this.getQuotation();
          showSuccess(res.info ||'Success');
        }else{
          this.setBidLoading = false;
          showError(res.info);
        }
      })
    },
    setOrderBid(flag = true) {
      // 如果已经锁定，直接返回
      if (this.isBiddingLocked) {
        showWarning('Please wait for the previous bid to complete');
        return;
      }

      // 设置锁定
      this.isBiddingLocked = true;
      this.currentItem.bidLoading = true;

      if (!flag) {
        this.setBidPrice();
      }
      const params =  {
        price: this.qupBidPrice,
        sale_id: this.currentItem.sale_id,
        order_id: this.currentItem.order_id
      }
      request.post('/api/ajax_bid',params).then(res => {
        if (res.status) {
          this.currentItem.bidLoading = false;
          this.bidFlag = false;
          // 等待 getOrdersList 完成后解锁
          // this.getOrdersList().finally(() => {
          //   this.isBiddingLocked = false;
          // });
          this.getOrdersList(
            false,
            this.activeCheckType
          )
          .then(() => {
            this.applyCurrentProductOrders();
          })
          .finally(() => {
            this.isBiddingLocked = false;
          });
          showSuccess(res.info || 'Success');
        } else {
          this.currentItem.bidLoading = false;
          this.isBiddingLocked = false;
          showError(res.info);
        }
      }).catch(err => {
        this.currentItem.bidLoading = false;
        this.isBiddingLocked = false;
        showError(err);
      });
    },
    getMoreTime(){
      request.post('/api/ajax_extend_reporting_time',{
        sale_id:this.currentItem.sale_id,
        order_id:this.currentItem.order_id
      }).then(res=>{
        if(res.status){
          this.getOrdersList(
            false,
            this.activeCheckType
          ).then(() => {
            this.applyCurrentProductOrders();
          });
          showSuccess(res.info ||'Success');
        }else{
          showError(res.info);
        }
      })
    },
    downLoadBid(item){
      item.downloadLoading = true;
      // 下载文件的完整示例
      let downUrl = `/api/download_paper?sale_id=${item.sale_id}&order_id=${item.order_id}`;
      // if(this.isIthenticate){
      //   downUrl += '&check_type=36'
      // }
      get(downUrl,{},{
        returnFullResponse: true,
        responseType: 'blob'
      }).then(response => {
        if (response.status === false) {
          showError(response.info)  // 这里处理业务错误
          return
        }
       
        const contentDisposition = response.headers['content-disposition'];
        // console.log(contentDisposition,'contentDisposition---');
        let filename = '';

        if (contentDisposition) {

          // 优先 filename*
          const utf8Match = contentDisposition.match(
            /filename\*=utf-8''([^;]+)/i
          );

          if (utf8Match && utf8Match[1]) {

            filename = decodeURIComponent(utf8Match[1]);

          } else {

            // fallback
            const normalMatch = contentDisposition.match(
              /filename="?([^"]+)"?/i
            );

            if (normalMatch && normalMatch[1]) {
              filename = normalMatch[1];
            }
          }
        }

        // 没拿到文件名
        if (!filename) {
          showError('Invalid filename');
          return;
        }

        // 如果文件名为空，使用默认名
        // if (!filename || filename === '_' || filename === '') {
        //   showError('Invalid filename');
        //   return;
        // }

        // 创建下载链接
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.getOrdersList(
          false,
          this.activeCheckType
        ).then(() => {
          this.applyCurrentProductOrders();
        });

      }).catch(error => {
        item.downloadLoading = false;
        let errorMessage = 'Failed';
        if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
          errorMessage = 'Timeout error';
        }
        else if (error.message?.includes('Network Error')) {
          errorMessage = 'Network Error';
        }
        else if (error?.info) {
          errorMessage = error.info;
        }
        else if (error.message) {
          errorMessage = error.message;
        }

        showError(errorMessage);
      });

    },
    decodeRFC5987Filename(header) {
        const match = header.match(/filename\*=(?:utf8|UTF-8)''([^;]+)/i);
        if (match) {
            return decodeURIComponent(match[1]);
        }
        // 回退到普通文件名（如 filename="xxx"）
        const fallbackMatch = header.match(/filename="?([^"]+)"?/i);
        return fallbackMatch ? fallbackMatch[1] : 'download';
    },
    async uploadFile(){
      if(this.reduceIncorrectNum > 0){
        showError('Please correct the incorrect files');
        return;
      }
      if (!this.isUploadValid) {
        showError('Please upload valid files');
        return;
      }

      // 批量上传模式（存在AI报告且文件数>2）
      if (this.isBatchMode) {
        await this.uploadBatchFiles();
        return;
      }

      // 普通上传模式
      await this.uploadSingleFile();
    },

    // 普通单组上传（2个文件）
    async uploadSingleFile() {
      try {
        this.confirmLoading = true;
        this.uploadStatus = 'uploading';
        this.percentage = 0;
        this.uploadController = new AbortController();
        await this.rebuildFormData();
        const res = await request.post('/api/upload_report', this.formData,
        {
          signal: this.uploadController.signal,
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              this.percentage = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
            }
          }
        }
        );
        if (res.status) {
          this.percentage = 100;
          this.uploadStatus = 'success';
          showSuccess(res.info || 'Success');
          this.is_exist_ai_report = '1'
          this.getOrdersList(
            false,
            this.activeCheckType
          ).then(() => {
            this.applyCurrentProductOrders();
          });
          this.getRecentOrdersList();
          this.uploadAndTimeFlag = false;
          var that = this
          setTimeout(()=>{
            that.resetUploadState()
          },1000)
        } else {
          this.$nextTick(() => {
            this.uploadStatus = 'error';
            this.uploadErrorInfo = res.info
          });
        }
      } catch (err) {
        console.log(err, 'err==');
        // ✅ 超时
        if (err.code === 'ECONNABORTED') {
          this.uploadStatus = 'error';
          this.uploadErrorInfo = 'Timeout error';
          return;
        }

        // ✅ 网络错误
        if (err.code === 'ERR_NETWORK') {
          this.uploadStatus = 'error';
          this.uploadErrorInfo = 'Network Error';
          return;
        }

        // ✅ 请求已发出但无响应（兼容判断）
        if (!err.response && err.request) {
          this.uploadStatus = 'error';
          this.uploadErrorInfo = 'Network Error';
          return;
        }

        // ✅ 业务错误（你 reject(res) 的情况）
        if (err.info) {
          this.uploadStatus = 'error';
          this.uploadErrorInfo = err.info;
          return;
        }

        // ✅ 兜底
        this.uploadStatus = 'error';
        this.uploadErrorInfo = err.message || 'Upload failed';
      } finally {
        this.confirmLoading = false;
      }
    },

    // 批量上传（按组顺序上传）
    async uploadBatchFiles() {
      // 验证分组
      const errors = this.validateFileGroups();
      if (errors.length > 0) {
        showError(errors.join('; '));
        return;
      }

      try {
        this.confirmLoading = true;
        this.isBatchUploading = true;
        this.uploadStatus = 'uploading';
        this.percentage = 0;
        this.batchUploadResults = [];

        // 逐组上传
        for (let i = 0; i < this.uploadGroups.length; i++) {
          this.currentGroupIndex = i;
          const group = this.uploadGroups[i];
          group.status = 'uploading';

          try {
            // 构建当前组的 FormData
            const formData = await this.buildGroupFormData(group);

            const res = await request.post('/api/upload_report', formData, {
              onUploadProgress: (progressEvent) => {
                if (progressEvent.total) {
                  // 计算总体进度
                  const groupProgress = progressEvent.loaded / progressEvent.total;
                  this.percentage = Math.round(((i + groupProgress) / this.uploadGroups.length) * 100);
                }
              }
            });

            // 测试
            // if(i == 0){
            //   group.status = 'success';
            //   group.visible = true;
            //   setTimeout(() => {
            //     group.visible = false;
            //   }, 2000);
            //   this.batchUploadResults.push({
            //     prefix: group.prefix,
            //     status: 'success',
            //     message: res.info || 'Success'
            //   });

            // }
            // else{
            //   group.status = 'error';
            //   group.errorMsg = res.info || 'Upload failed';
            //   this.batchUploadResults.push({
            //     prefix: group.prefix,
            //     status: 'error',
            //     message: res.info || 'Upload failed'
            //   });
            // }

            if (res.status) {
              group.status = 'success';
              group.visible = true;
              setTimeout(() => {
                group.visible = false;
              }, 2000);
              this.batchUploadResults.push({
                prefix: group.prefix,
                status: 'success',
                message: res.info || 'Success'
              });
            } else {
              group.status = 'error';
              group.errorMsg = res.info || 'Upload failed';
              this.batchUploadResults.push({
                prefix: group.prefix,
                status: 'error',
                message: res.info || 'Upload failed'
              });
              // 继续上传下一组，不中断
            }
          } catch (err) {
            console.log(err, 'batch upload error==');
            group.status = 'error';
            const errorMsg = err.info || err.message || 'Upload failed';
            group.errorMsg = errorMsg;
            this.batchUploadResults.push({
              prefix: group.prefix,
              status: 'error',
              message: errorMsg
            });
            // 继续上传下一组，不中断
          }
        }

        // 所有组上传完成
        // this.percentage = 100;
        // const successCount = this.batchUploadResults.filter(r => r.status === 'success').length;
        const errorCount = this.errorCount =  this.batchUploadResults.filter(r => r.status === 'error').length;

        if (errorCount === 0) {
          // showSuccess(`All ${successCount} orders uploaded successfully`);
          // this.is_exist_ai_report = '1';
          this.getOrdersList(
            false,
            this.activeCheckType
          ).then(() => {
            this.applyCurrentProductOrders();
          });
          this.getRecentOrdersList();
          // this.uploadAndTimeFlag = false;
          setTimeout(() => {
            //   this.resetUploadState();
            this.uploadStatus = 'success';
          }, 2000);
        } else {
          this.uploadStatus = 'error';
          // this.uploadErrorInfo = `${successCount} success, ${errorCount} failed`;
        }
      } catch (err) {
        console.log(err, 'batch upload fatal error==');
        this.uploadStatus = 'error';
        // this.uploadErrorInfo = err.message || 'Batch upload failed';
      } finally {
        this.confirmLoading = false;
        this.isBatchUploading = false;
      }
    },

    // 构建单组的 FormData
    async buildGroupFormData(group) {
      const formData = new FormData();

      // 添加文件（同组的2个文件）
      group.files.forEach(item => {
        const rawFile = item.file.raw || item.file;
        formData.append('report_file[]', rawFile);
      });

      if(this.is_exist_ai_report == '1'){
        formData.append('is_exist_ai_report', 'true');
        if(this.allowBatchUpload){
          formData.append('is_mutil_upload', '1');
        }else{
          formData.append('is_mutil_upload', '0');
        }
      }else{
        formData.append('is_exist_ai_report', 'false');
        formData.append('is_mutil_upload', '0');
      }
      // 其他参数
      if (this.currentItem) {
        formData.append('sale_id', this.currentItem.sale_id);
        formData.append('order_id', this.currentItem.order_id);
      }

      return formData;
    },
    resetUploadState() {
      this.uploadStatus = 'idle';   // ✅ 隐藏进度条
      this.percentage = 0;

      this.fileList = [];
      this.formData = new FormData();
      this.uploadGroups = [];
      this.currentGroupIndex = 0;
      this.batchUploadResults = [];
      this.isBatchUploading = false;

      this.uploadController = null;
    },
    cancelBidHandle(item){
      this.currentItem = item;
      this.actionMode = 'cancel'
      this.actionOrderFlag = true;
    },
    keepOrderStatus(){
      this.actionOrderFlag = false;
      this.ruleForm.cancel_reason = '';
    },
    cancelBid(item,type){
      if(type== 'success' && this.ruleForm.cancel_reason?.trim() == ''){
        showError('Please enter a reason for cancellation');
        return;
      }
      const params ={
        sale_id:item.sale_id,
        order_id:item.order_id,
        reason:this.ruleForm.cancel_reason || ''
      }
      item.cancelLoading = true;
      request.post('/api/ajax_cancle_bid',params).then(res=>{
        if(res.status){
          this.getOrdersList(
            false,
            this.activeCheckType
          ).then(() => {
            this.applyCurrentProductOrders();
          });
          item.cancelLoading = false;
          if(type== 'success'){
            this.actionOrderFlag = false;
            this.ruleForm.cancel_reason = '';
          }
          showSuccess(res.info ||'Success');
        }else{
          item.cancelLoading = false;
          showError(res.info);
        }
      })

    },
    logoOutfun(){
      logoOut();
    },
    backUpload(){
      // this.isOnlyMoreTime = true;
      // this.uploadFlag = true;
      // this.moreTimeFlag = false;
      this.dialogMode = 'upload'
      this.canBackToUpload = false
    },
    handleChange(file, fileList) {
      const newFile = file.raw;
      if (!newFile) return;
      if (this.isBatchMode) {
        // 存在AI报告时，支持批量上传（最多10个文件，按文件名前8位分组，每组2个）
        this.handleBatchUploadChange(file, fileList);
      } else {
        // 不存在AI报告时，保持原有逻辑（最多2个文件：1 PDF + 1 Image）
        // 存在，但不允许批量
        this.handleNormalUploadChange(file, fileList);
      }
    },

    // 处理普通上传（不存在AI报告）
    handleNormalUploadChange(file) {
      const newFile = file.raw;
      if (!newFile) return;

      // 检查重复文件（根据文件名和文件大小）
      const isDuplicate = this.fileList.some(existingFile => {
        const existingRaw = existingFile.raw || existingFile;
        return existingRaw.name === newFile.name && existingRaw.size === newFile.size;
      });

      if (isDuplicate) {
        showError(`File "${newFile.name}" has already been added`);
        return;
      }

      const currentFiles = this.fileList.map(f => f.raw || f);
      const nextFiles = [...currentFiles, newFile];
      const pdfFiles = nextFiles.filter(f => f.type === 'application/pdf');
      const imgFiles = nextFiles.filter(f =>
        ['image/jpeg', 'image/png'].includes(f.type)
      );
      if (this.is_exist_ai_report === '1') {
        //只允许 PDF（最多2个）
        if (newFile.type !== 'application/pdf') {
          showError('Only PDF allowed');
          return;
        }
        if (nextFiles.length > 2) {
          showError('Only 2 PDF files allowed');
          return;
        }

      } else {
        // 1 PDF + 1 Image
        if (!(newFile.type === 'application/pdf' || ['image/jpeg', 'image/png'].includes(newFile.type))) {
          showError('Only PDF or Image');
          return;
        }

        if (pdfFiles.length > 1 || imgFiles.length > 1 || nextFiles.length > 2) {
          showError('Only 1 PDF + 1 Image');
          return;
        }
      }

      this.fileList.push(file);
      this.rebuildFormData();
    },

    // 处理批量上传（存在AI报告）
    handleBatchUploadChange(file, fileList) {
      console.log(fileList)
      const newFile = file.raw;
      if (!newFile) return;

      if (!this.isBatchMode) {
        return this.handleNormalUploadChange(file, fileList);
      }
       // 禁止批量时限制2个文件
      if (!this.allowBatchUpload && this.fileList.length >= 2) {
        showError('Only 2 files allowed when batch upload is disabled');
        return;
      }
      // 检查文件类型（必须是PDF）
      if (newFile.type !== 'application/pdf') {
        showError('Only PDF files are allowed');
        return;
      }

      // 检查是否超过10个文件
      if (this.fileList.length >= this.reportFileLimit) {
        showError('Maximum 10 files allowed');
        return;
      }

      // 检查重复文件（根据文件名和文件大小）
      const isDuplicate = this.fileList.some(existingFile => {
        const existingRaw = existingFile.raw || existingFile;
        return existingRaw.name === newFile.name && existingRaw.size === newFile.size;
      });

      if (isDuplicate) {
        showError(`File "${newFile.name}" has already been added`);
        return;
      }

      // 添加文件到列表
      this.fileList.push(file);

      // 重新分组
      this.groupFilesByName();
      this.rebuildFormData();
    },

    // 按文件名前8位数字分组
    groupFilesByName() {
      const groups = new Map();

      this.fileList.forEach((file, index) => {
        const rawFile = file.raw || file;
        const fileName = rawFile.name;
        // 提取前8位数字
        const prefixMatch = fileName.match(/^(\d{8})/);
        const prefix = prefixMatch ? prefixMatch[1] : 'unknown';

        if (!groups.has(prefix)) {
          groups.set(prefix, []);
        }
        groups.get(prefix).push({ file, index, prefix });
      });

      // 转换为数组格式
      this.uploadGroups = Array.from(groups.entries()).map(([prefix, files]) => ({
        prefix,
        files,
        status: 'pending', // pending, uploading, success, error
        errorMsg: ''
      }));
    },

    // 验证分组是否有效（每组2个文件） --- ith除外
    validateFileGroups() {
      const errors = [];
      this.uploadGroups.forEach(group => {
        // 文件名前缀异常
        if (group.prefix === 'unknown') {
          errors.push(
            `Group "${group.prefix}": file name must keep first 8 digits`
          );
          return;
        }
        // ithenticate 允许单文件
        if (!this.isIthenticate && group.files.length !== 2) {
          errors.push(
            `Group "${group.prefix}": must have exactly 2 files (found ${group.files.length})`
          );
        }
      });
      return errors;
    },
    handleSuccess(){
      this.confirmLoading = false;
      showSuccess('Upload Success');
      this.formData.delete('report_file[]');
      this.uploadFile();
      setTimeout(()=>{
        // this.moreTimeFlag = true;
        // this.isOnlyMoreTime = true;
        // this.uploadFlag = false;
      },1000)
    },
    handleMoreTime(){
      this.getMoreTime()
      this.uploadAndTimeFlag = false;
      // this.moreTimeFlag = false;
      // this.isOnlyMoreTime = false;
    },
    closeExtendTime(){
      this.canBackToUpload = false;
      this.uploadAndTimeFlag = false;
      this.dialogMode = 'moreTime'
      // this.moreTimeFlag = false;
      // this.isOnlyMoreTime = false;
    },
    changeMoreTime(){
      if(this.currentItem.extend_report_times >= this.extend_report_max_times){
        showError('Max 3 bid!');
        return;
      }
      // this.isOnlyMoreTime = true;
      // this.uploadFlag = false;
      // this.moreTimeFlag = true;
      this.dialogMode = 'moreTime'
      this.canBackToUpload = true
    },
    openBidModal(item) {
      event?.preventDefault();

      // 检查是否被锁定
      if (this.isBiddingLocked) {
        showWarning('Please wait for the previous bid to complete');
        return;
      }

      this.currentItem = item;
      item.bidLoading = true;

      if (this.activePendingTotal >= this.maxOrderGrab) {
        showWarning(`Max ${this.maxOrderGrab} active bids · Finish one to bid more`);
        item.bidLoading = false;
        return;
      }

      if (Number(this.qupBidPrice) == 0 || this.qupBidPrice == '') {
        showError('Please enter a valid bid price');
        item.bidLoading = false;
        return;
      }

      // 当前最低价不是本用户 ; 当前有人和本用户报价一致且都是最低价
      if ((!item.min_price_is_current_login_user && this.qupBidPrice == item.min_price) || this.qupBidPrice > item.min_price) {
        this.bidFlag = true;
        item.bidLoading = false;
      } else {
        item.bidLoading = false;
        this.setOrderBid();
      }
    },
    removeFile(index){
      this.fileList.splice(index, 1);
      // 重新分组（如果是批量上传模式）
      if (this.is_exist_ai_report === '1') {
        this.groupFilesByName();
      }
      // 重新构建 FormData
      this.rebuildFormData();
    },
    rebuildFormData() {
      // 清空原有的 FormData
      this.formData = new FormData();
      if (this.currentItem) {
        this.formData.append('sale_id', this.currentItem.sale_id);
        this.formData.append('order_id', this.currentItem.order_id);
      }
      if(this.is_exist_ai_report == '1'){
        this.formData.append('is_exist_ai_report', 'true');
        if(this.allowBatchUpload){
          this.formData.append('is_mutil_upload', '1');
        }else{
          this.formData.append('is_mutil_upload', '0');
        }
      }else{
        this.formData.append('is_exist_ai_report', 'false');
        this.formData.append('is_mutil_upload', '0');
      }
      // if (this.isIthenticate){
      //   this.formData.append('check_type', '36');
      // }

      // 重新添加所有剩余的文件
      this.fileList.forEach(file => {
        if (file.raw) {
          this.formData.append('report_file[]', file.raw);
        } else {
          console.warn('File raw data not found:', file);
        }
      });
    },
    goWithdraw(type){
      if(type == 'first'){
        this.$router.push('/rules');
      }else if(type == 'brands'){
        this.$router.push('/selectBrands');
      }
      else{
        this.$router.push('/withdraw');
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this._unlockAudio) {
      ['click', 'touchstart', 'keydown'].forEach((evt) => {
        document.removeEventListener(evt, this._unlockAudio);
      });
    }
    if (this._onVisibilityChange) {
      document.removeEventListener('visibilitychange', this._onVisibilityChange);
    }
    this.stopPolling()
    this.stopProductPolling()
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
  },
}
</script>

<style>
.el-tooltip__popper.my-tooltip[x-placement^="bottom"] .popper__arrow {
  left: 75% !important;
  right: 10% !important;
}
</style>
<style lang="scss" scoped>
.time_out_box .timeInfo{
  margin-left: 24px;
}
.flash {
  animation: popFlash 0.5s ease;
}
.quotationWrap {
  ::v-deep .el-switch.is-checked .el-switch__core {
    border-color: var(--primary-color) !important;
    background-color: var(--primary-color) !important;
  }
}
@keyframes popFlash {
  0% {
    transform: scale(1);
    opacity: 0.6;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.8;
  }
}
::v-deep .el-collapse-item__header{
  padding: 20px;
  box-sizing: border-box;
  line-height: 24px;
  height: 54px;
}
::v-deep .el-collapse-item__arrow {
  display: none;
}
::v-deep .el-collapse-item__wrap{
  // max-height: 368px;
  padding: 0px 20px;
  overflow-y: auto;
}
::v-deep .el-checkbox__input.is-checked+.el-checkbox__label{
  color: #22285E;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: var(--primary-hover);
  border-color: #fff;
}
::v-deep .el-checkbox__inner{
  width: 18px;
  height: 18px;
  border: 1px solid #98909E;
}
::v-deep .el-checkbox__inner::after{
  height: 12px;
  left: auto;
}
.fileNameTop{
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: normal;
}
.quotationWrap{
  min-width: 1190px;
  max-width: 1900px;
  margin: 0 auto;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  overflow-y: auto;
  color: #22285E;
  padding: 28px 44px 0 44px;
  background: #F5F2FF;

  .soundOn{
    color: var(--primary-color);
  }
  .soundOff{
    color: #5F5B70;
  }
  .header{
    height: 31px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .soundOn, .soundOff{
      font-weight: normal;
    }
    .header-left{
      font-size: 20px;
      color: #5F5B70;
      font-weight: bold;
      .LogoName{
        color: var(--primary-color);
      }
    }
    .header-right{
      display: flex;
      gap: 24px;
      p{
        align-items: baseline;
        color: #22285E;
        font-size: 14px;
        line-height: 21px;
      }
      span{
        font-size: 32px;
        font-weight: 600;
        color: var(--primary-color);
      }
    }
  }

  .contentBox{
    margin-top: 30px;
    align-items: flex-start;
    // height: calc(100% - 61px);
    .fixedWrap{
      position: sticky;
      top: 0;
    }
    .rulesBox{
      color: var(--btn-default-color);
    }
    .top-notice{
      border-radius: 6px 6px 0 0;
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
      .noticeWrap{
        gap: 4px 8px;
        flex-wrap: wrap;
        align-items: flex-start;
        max-width: 100%;
        span{
          flex: 0 1 auto;
          min-width: 0;
          max-width: 100%;
          word-break: break-word;
          line-height: 1.5;
          i{
            text-decoration: underline;
            font-style: normal;
          }
        }
      }
      span{
        i{
          text-decoration: underline;
          font-style: normal;
        }
      }
    }

    .more-link{
      font-size: 12px;
      text-decoration: underline;
      color: #22285E;
      padding-left: 4px;
    }

    .userWrap{
      min-width: 140px;
      max-width: 140px;
      min-height: 150px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 12px;
      border-radius: 8px;
      background: linear-gradient(0deg, #FFFFFF, #FFFFFF), #FFFFFF;
      box-shadow: 0px 4px 10px 0px rgba(166, 147, 244, 0.77);
      .avator{
        margin-bottom: 12px;
        width: 36px;
        height: 36px;
        border: 2px solid var(--primary-color);
      }
      .desc{
        color: #999999;
        span{
          color: var(--btn-default-color);
        }
      }
      .operate-btn{
        width: 116px;
        height: 36px;
        font-size: 12px;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        padding: 6px 15px;
        box-sizing: border-box;
        gap: 4px;
        border-radius: 100px;
        background: var(--btn-primary-gradient);
        box-sizing: border-box;
        border: 1px solid #5D45BF;
        margin-top: 18px;
      }
      .btn1{
        border: none;
        color: var(--btn-default-color);
        background: var(--btn-default-gradient);
        transition: all .3s;
      }
      .btn1:hover{
        opacity: .7;
        transition: all .3s;
      }
      .btn1:active{
        opacity: 1;
        transition: all .3s;
      }
      .btn2{
        background: #fff;
        color: #5F5B70;
        border: 1px solid #EFECF6;
      }
    }
    .pendingWrap{
      margin-top: 12px;
      width: 140px;
      // height: 113px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 12px;
      gap: 8px;
      align-self: stretch;
      border-radius: 8px;
      background: linear-gradient(0deg, #FFFFFF, #FFFFFF), #FFFFFF;
      box-shadow: 0px 4px 10px 0px rgba(166, 147, 244, 0.77);
      .pending-total{
        font-weight: 600;
        font-size: 38px;
        line-height: 38px;
        color: #F0351C;
      }
      .boldTitle{
        line-height: 21px;
      }
      .gotop{
        align-items: center;
      }
    }
    .soundWrap{
      gap: 12px;
    }

    .main{
      flex:1;
      min-width: 935px;
      height: 100%;
      display: flex;
      flex-direction: column;

      .iden-number{
        line-height: 16px;
        text-align: center;
        margin: 0 4px;
        display: inline-block;
        width: 16px;
        min-width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #F0351C;
        color: #fff;
      }


      .main-top{
        .top-one{
          width: 100%;
          height: 74px;
          box-sizing: border-box;
          padding: 12px 24px;
          box-sizing: border-box;
          border-radius: 8px 8px 0px 0px;
          // background: linear-gradient(270deg, #7B3AED 36%, #5045E6 109%), #FFFFFF;
          // box-shadow: 0px 4px 10px 0px rgba(166, 147, 244, 0.77);
          background: var(--primary-gradient);
          box-shadow: var(--primary-shadow);
          .one-left{
            color: #fff;
            gap: 24px;
            .boldTitle{
              font-size: 20px;
              color: #fff;
            }
          }
        }
        .main-input{
          width: 200px;
          height: 50px;
          .input__icon{
            color: #fff;
            font-size: 24px;
          }
          ::v-deep input{
            color: #fff;
            font-size: 30px;
            font-weight: 600;
            background: transparent;
          }
          ::v-deep input::placeholder{
            font-size: 14px;
          }
        }
        .confirmBidBtn{
          min-width: 120px;
          height: 40px;
          padding: 11px 12px;
          box-sizing: border-box;
          font-size: 12px;
          font-weight: 600;
          line-height: normal;
          text-align: center;
          letter-spacing: normal;
          color: var(--primary-color);
          border-radius: 8px;
          background: #FFFFFF;
          border: none;
          box-shadow: 0px 4px 10px 0px rgba(166, 147, 244, 0.77);
        }
      }
      .main-bottom{
        .success{
          font-weight: bold;
          color: #1CB89C;
        }
        .failed{
          font-weight:600;
          color: #F0351C;
        }
        .bidStatusCur{
          min-width: 128px;
          width: auto;
        }
        .rorate180{
          transform: rotate(180deg);
        }
        .expandTitle{
          width: 100%;
          .num{
            margin-left: 12px;
            min-width: 28px;
            height: 22px;
            display: flex;
            flex-direction: column;
            padding: 1px 10px;
            box-sizing: border-box;
            border-radius: 12px;
            background: #F0351C;
            font-weight: 600;
            line-height: 20px;
            letter-spacing: normal;
            color: #FFFFFF;
          }
        }
        .expandText{
          color: var(--primary-color);
        }
      }
      .main-list{
        padding: 0 20px 12px;
        border-radius: 8px;
        background: #fff;
      }

      .main-list{
        // height: calc(100% - 110px);
        // overflow: auto;
        .successTitle{
          span{
            font-weight: normal;
            color: #5F5B70;
            i{
              font-style: normal;
              color: #F0351C;
            }
          }
        }


        .list-item{
          width: 100%;
          border-bottom: 1px solid #E9E9E9;
          display: flex;
          align-items: center;
          padding: 12px 0px;
          gap: 12px;
          text-align: left;
          box-sizing: border-box;
          align-self: stretch;
          color: #22285E;

          .item-left{
            flex: 1;
            min-width: 0;

            .boldTitle{
              margin-bottom: 12px;
              text-align: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 100%;
            }
          }
        }
      }
    }
  }
  .newOrdersNumBox{
    padding: 5px 24px;
    box-sizing: border-box;
    gap: 10px;
    border-radius: 8px;
    color: var(--primary-color);
    font-size: 12px;
    background: rgba(255, 255, 255, 0.7);
    span{
      font-size: 38px;
      font-weight: 600;
    }
    .boldTitle{
      color: var(--primary-color);
      font-size: 14px;
      margin-right: 10px;
    }
    .desc{
      color: #999999;
    }
  }
  .theme-switch-card {
    .theme-item {
      position: relative;
      width: 100%;
      margin-bottom: 8px;
  
      cursor: pointer;
  
      transition: all 0.25s ease;
  
      &:last-child {
        margin-bottom: 0;
      }
  
      .theme-content {
        height: 54px;
        padding: 6px 12px;
        box-sizing: border-box;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
  
        font-weight: 600;
  
        transition: all 0.25s ease;
  
        background: var(--btn-default-gradient);
  
        color: var(--btn-default-color);
        .ft12{
          font-weight: normal;
          gap: 6px;
          display: flex;
          i{
            font-style: normal;
          }
        }
      }
  
      .badge {
        position: absolute;
        top: -10px;
        right: -8px;
        background: #ff3b1f;
  
        color: #fff;
        border-radius: 100px;

        font-weight: 500;
        font-size: 12px;
  
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        z-index: 2;
        padding: 0px 6px;

        span{
          font-size: 16px;
          font-weight: 600;
        }
      }
  
      .arrow {
        position: absolute;
        right: -10px;
        top: 50%;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-top: 12px solid transparent;
        border-bottom: 12px solid transparent;
        border-left: 12px solid var(--primary-hover);
      }
  
      &.active {
        .theme-content {
          background: var(--primary-gradient);
  
          color: #fff;
  
          box-shadow: var(--primary-shadow);
        }
      }
    }
  }

}

.list-item{
  width: 100%;
  border-bottom: 1px solid #E9E9E9;
  display: flex;
  align-items: center;
  padding: 12px 0px;
  gap: 12px;
  box-sizing: border-box;
  align-self: stretch;
  &:nth-last-child(1){
    border-bottom: none !important;
  }
  .item-left{
    flex: 1;
    min-width: 0;

    .boldTitle{
      margin-bottom: 12px;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
    }
  }

  .item-right{
    display: flex;
    flex-direction: column;
    align-items: stretch;
    min-width: 280px;
    gap: 12px;

    .right-top{
      cursor: pointer;
      line-height: 24px;
      // margin-bottom: 12px;
      justify-content: flex-end;
      .moreTimeTip{
        position: absolute;
        left: 0%;
        transform: translateX(-75%);
        top: -28px;
        white-space: nowrap;
      }
      .column{
        position: relative;
        align-items: end;
      }
      .desc{
        color: var(--primary-color);
      }
      .timeInfoText{
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        letter-spacing: normal;
        color: #F0351C;
      }
      // .time_out_box{
      //   height: 45px;
      //   min-width: 150px;
      //   flex: 1;
      //   justify-content: flex-end;
      // }
      .timeInfo{
        min-width: 72px;
        height: 22px;
        font-weight: 600;
        display: flex;
        flex-direction: column;
        padding: 1px 10px;
        box-sizing: border-box;
        color: #fff;
        line-height: 22px;
        border-radius: 12px;
        background: #F0351C;
        &:hover{
          opacity: .7;
          transition: all .3s;
        }
      }

      .time_out_box {
        position: relative;
        display: flex;
        height: 45px;
        min-width: 130px;
        flex: 1;
        justify-content: flex-end;
      }

      /* tooltip本体 */
      .custom-tooltip {
        position: absolute;
        bottom: -40px;   /* 控制上下位置 */
        right: 0;        /* ✅ 右对齐 */
        background: #303133;
        color: #fff;
        padding: 6px 10px;
        font-size: 12px;
        border-radius: 4px;
        white-space: nowrap;
        z-index: 10;
      }

      /* 小箭头 */
      .custom-tooltip .arrow {
        position: absolute;
        top: -6px;
        right: 12px;   /* ✅ 控制箭头靠右 */
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #303133;
        // border-top: 12px solid transparent;
        // border-bottom: 12px solid transparent;
        // border-left: 12px solid var(--primary-hover);
      }
      .custom-tooltip {
        opacity: 0;
        transform: translateY(5px);
        transition: all 0.2s ease;
      }

      .time_out_box:hover .custom-tooltip {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .right-bottom{
      justify-content: flex-end;
      flex-wrap: wrap;

      .curBid{
        color: #FB832D
      }
      .curBidPending{
        color: #5E46BF
      }
      .downLoad{
        font-size: 12px;
        font-weight: 600;
        line-height: normal;
        text-align: center;
        letter-spacing: normal;
        color: #989BA1;
      }

      .btn {
        cursor: pointer;
        padding: 6px 12px;
        border-radius: 6px;
        font-size: 12px;
        transition: all 0.3s;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }

  .bidStatusWin,
  .bidStatusWait,
  .bidStatusCur,
  .bidStatusNot {
    width: 100%;
    max-width: 392px !important;
    min-height: 40px;
    font-size: 12px;
    padding: 8px 12px;
    box-sizing: border-box;
    border-radius: 8px;
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
  }

  .bidStatusWin {
    background: #EDFFFC;
  }

  .bidStatusWait {
    background: #FDF7F4;
  }

  .bidStatusCur,
  .bidStatusNot {
    gap: 12px;
    background: #F9F4FD;

    .ft16 {
      color: var(--primary-color);
      font-weight: 600;
    }
  }
  .bidStatusNot{
    max-width: 392px !important;
  }
}
.list-item1{
  padding: 5px 0 !important;
  .item-left{
    flex: none !important;
    max-width: calc(100% - 450px);
  }
  .item-right{
    flex: 1 !important;
    min-width: 360px;
  }
}
.group-item{
  border-radius: 8px;
  background: #F5F9FC;
  margin-bottom: 12px;
  .group-header{
    padding: 12px 24px 12px 12px;
    min-height: 68px;
    align-items: flex-start;
    display: flex;
    box-sizing: border-box;
    flex-direction: column;
    justify-content: space-around;
    .group-title{
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
  }
  .group-files{
    .file-item{
      padding: 12px;
      box-sizing: border-box;
      border-bottom: 1px dashed #DDDCE4;
    }
    .fileInfo{
      width: 100%;
    }
    &:last-child{
      border:none;
    }
  }
  .group-status{
    font-size: 12px;
    // color: #F0351C;
  }
  .error{
    color: #F0351C;
  }
  .uploading{
    color: var(--primary-color);
  }
  .success{
    color: #1CB89C;
  }
  .pending{

  }
}
.group-item-warn{
  background: #FCF5F5;
}
.group-item-success{
  background: #F1FDED;
}

// 移动端头部
.mobile-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: rgba(255,255,255);
  margin-bottom: 12px;
  /* 顶部悬浮栏 */
  .header-bar {
    position: sticky;
    top: 0;
    z-index: 1000;
    height: 64px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
  }

  /* 左侧 */
  .left {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .name {
    font-weight: 600;
  }

  .balance {
    font-size: 12px;
    color: #999;
  }

  .balance span {
    color: #6c4df6;
    font-weight: bold;
  }

}
::v-deep .van-popup{
  border-radius: 8px 8px 0 0;
  padding: 12px 20px;
  box-sizing: border-box;
  .panel-btn {
    width: 100%;
    height: 48px;
    border-radius: 12px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
  }

  /* 样式 */
  .primary {
    background: var(--btn-primary-gradient);
    color: #fff;
  }

  .secondary {
    background: #eee7ff;
    color: #6c4df6;
  }

  .ghost {
    border: 1px solid #ddd;
    color: #999;
  }
}


.input__icon{
  height: 100%;
  color: #5E46BF;
  display: flex;
  align-items: center;
}

.unit,.unit-r{
  min-width: 127px;
  height: 30px;
  font-size: 12px;
  margin-top: 10px;
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 100px;
  background: #F7F1FC;
  color: var(--primary-color);
  white-space: nowrap;
}

.unit-r{
  min-width: auto;
  width: fit-content;
  max-width: 100%;
  color: #FFFFFF;
  margin-top: 0;
  background: rgba(248, 241, 252, 0.2);
}

.inputWrap{
  width: 300px;
}

::v-deep input{
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 6px 10px 30px;
  align-self: stretch;
  border-radius: 8px;
  background: #FFFFFF;
  box-sizing: border-box;
}

.biddingDialog{
  .content{
    margin: 10px 0;
    align-items: center;
    justify-content: center;
    .desc{
      color: #989BA1;
    }
  }
}

.progressBox{
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}
::v-deep .el-progress-bar{
  padding-right: 0;
}
::v-deep .el-progress__text{
  text-align: right;
}

.uploadAndTimeDialog{
  .uploadGroupsWrap{
    max-height: 300px;
    overflow-y: scroll;
  }
  .uploadGroupsWrap::-webkit-scrollbar {
    width: 4px;
  }
  .uploadGroupsWrap::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
  }
  .upload-demo2{
    width: 130px;
  }
  .pendProgress{
    text-align: right;
    color: #9E9E9E;
    justify-content: flex-end;
    span{
      color: #FB832D;
    }
  }
  .errorTip{
    color: #F0351C;
    font-size: 12px;
    font-weight: 500;
    text-align: left;
    justify-content: flex-end;
  }
  .hasReport{
    margin-bottom: 12px;
    span{
      width: calc((100% - 16px) / 2);
      height: 49.09px;
      display: flex;
      justify-content: center;
      box-sizing: border-box;
      align-items: center;
      // padding: 14.8px 48.13px 14.8px 48.12px;
      flex-grow: 1;
      border-radius: 12px;
      background: #FFFFFF;
      box-sizing: border-box;
      border: 1.5px solid #DDDCE4;
      transition: all .3s;
      cursor: pointer;
    }
    .active{
      transition: all .3s;
      background: var(--btn-default-gradient);
      box-sizing: border-box;
      border: 1.5px solid var(--border-color);
    }
  }
  .allowUploadBox,.normalUpload{
    background: var(--layout-bg);
    z-index: 9;
    margin-bottom: -49px;
    text-align: center;
    width: calc(100% - 4px);
    margin-left: 2px;
    padding: 6px 0px;
    border-radius: 6px 6px 0 0;
    box-sizing: border-box;
  
  }
  .normalUpload{
    background: #E0E4E7;
  
  }
  .example-card {
    width: 100%;
    padding: 20px;
    background: #f5f7fa;
    border-radius: 12px;
    box-sizing: border-box;
    /* 上部分 */
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .left .desc {
      margin-top: 6px;
      color: #8c8c8c;
      font-size: 14px;
    }

    /* 右侧 */
    .right {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .images {
      display: flex;
      gap: 6px;
    }

    .thumb {
      width: 60px;
      height: 40px;
      border-radius: 4px;
      object-fit: cover;
    }

    .enlarge {
      color: #65748B;
      cursor: pointer;
      font-size: 14px;
      white-space: nowrap;
    }

    /* 底部提示 */
    .tip {
      margin-top: 16px;
      color: #ff7a00;
      font-size: 14px;
      display: flex;
      align-items: center;
    }

    .icon {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: #ff7a00;
      color: #fff;
      font-size: 12px;
      margin-right: 8px;
    }
}
  .switchWrap{
    gap: 6px;
    .flex{
      gap: 6px;
    }
    span{
      padding: 2px 10px;
      border-radius: 30px;
      background: #E1D8F0;
      color: #22285E;
    }
    .active{
      background: #1CB89C;
    }
  }
  .uploadBtn2{
    width: 100%;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 11px 12px;
    gap: 4px;
    border-radius: 8px;
    background: var(--btn-default-gradient);
    box-sizing: border-box;
    border: 1px solid var(--border-color);
    font-size: 12px;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    letter-spacing: normal;
    color: var(--primary-color);
  }
  .batch-stats{
    i{
      font-style: normal;
      font-size: 22px;
    }
  }
  .fileListWrap{
    max-height: 250px;
    overflow-y: auto;
    .file-item{
      width: 100%;
      padding: 6px 24px 6px 12px;
      gap: 12px;
      align-self: stretch;
      box-sizing: border-box;
      border-radius: 8px;
      background: #F5F9FC;
      margin-bottom: 12px;
    }
    .fileInfo{
      display: flex;
      flex: 1;
      flex-direction: column;
      align-items: center;
      gap: 12px;
    }
    .fileName{
      width: 100%;
      img{
        cursor: pointer;
        width: 20px;
        height: 20px;
      }
    }
  }
}

::v-deep .el-upload{
  width: 100%;
}


::v-deep .el-upload-dragger{
  width: 100%;
  height: 240px;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  background: #F5F9FC;
  border: 2px dashed #DDDCE4;
  transition: all .3s;
}
::v-deep .el-upload__click{
  span{
    color: #5B3CC4
  }
}
::v-deep .el-upload-dragger:hover{
  .upload__click{
    color: var(--primary-color);

  }
  transition: all .3s;
  background: rgba(245, 242, 255, 0.4);
  border: 2px dashed rgba(95, 71, 194, 0.4);
}

::v-deep .el-upload__input{
  display: none !important;
}

.title{
  justify-content: center;
  flex-direction: column;
  p{
    font-size: 14px;
    color: #5F5B70;
    font-weight: normal;
    margin: 0;
    gap: 12px;
    span{
      color: #5F5B70;
    }
    .warnTime{
      color: #F0351C;
    }
  }
}

.useTimes{
  height: 29px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 20px;
  align-self: stretch;
  background: #F9F4FD;
  font-weight: normal;
  line-height: normal;
  letter-spacing: normal;

  .left{
    background: var(--primary-color);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }

  .right{
    display: flex;
    gap: 10px;
    span{
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background: var(--btn-primary-gradient);
    }
    .active{
      background: #E1E1E1;
    }
  }
}


// 响应式样式 - 平板 / 窄屏桌面（与 min-width: 1190px 衔接）
@media screen and (max-width: 1190px) {
  .quotationWrap {
    min-width: auto;
    padding: 20px 24px 0 24px;

    .header {
      .header-left {
        font-size: 16px;

        .boldTitle {
          font-size: 14px;
        }
      }

    }

    .contentBox {
      .userWrap {
        min-width: 100px;
        max-width: 100px;

        .nick {
          font-size: 12px;
        }
      }
      .pendingWrap{
        min-width: 100px;
        max-width: 100px;
      }

      .main {
        min-width: 300px;
        .success-top{
          padding-bottom: 0;
          .successTitle{
            flex-direction: column;
            align-items: flex-start;
            gap: 6px;
            margin-bottom: 12px;
          }
          .btn{
            margin-top: 0;
            min-width: 110px;
          }
        }
        .noticeWrap{
          flex-wrap: wrap;
        }

        .main-top {
          .top-one {
            flex-direction: column;
            height: auto;
            gap: 12px;

            .one-left {
              flex-direction: column;
              gap: 8px;

              .boldTitle {
                font-size: 18px;
              }
            }

            .one-right {
              width: 100%;
              flex-wrap: wrap;
              justify-content: flex-start;

              .unit-r {
                font-size: 11px;
                width: fit-content;
                max-width: 100%;
              }

            }
          }
        }

        .main-list {
          .list-item {
            flex-direction: column;
            align-items: stretch;

            .item-left {
              width: 100%;

              .boldTitle {
                white-space: normal;
                word-break: break-word;
              }
            }

            .item-right {
              width: 100%;
              min-width: auto;

              .right-top {
                justify-content: flex-start;
              }

            }

            .bidStatusWin,
            .bidStatusWait,
            .bidStatusCur,
            .bidStatusNot {
              width: 100%;
              font-size: 11px;
            }

          }
        }
      }
    }
  }
}

// 响应式样式 - 手机
@media screen and (max-width: 768px) {
  ::v-deep .el-dialog {
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%,-50%) !important;;
    margin: 0 auto !important;

    .el-dialog__wrapper {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      overflow: auto;
      margin: 0;
    }
  }

  ::v-deep .v-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .quotationWrap {
    padding: 16px 16px 0 16px;

    .header {
      flex-direction: column;
      align-items: flex-start;
      height: auto;
      gap: 12px;
      margin-bottom: 16px;

      .header-left {
        // flex-direction: column;
        // gap: 8px;

        .LogoName {
          font-size: 18px;
        }

        .boldTitle {
          font-size: 12px;
        }
      }
    }

    .contentBox {
      flex-direction: column;
      margin-top: 16px;
      height: auto;

      .userWrap {
        flex-direction: row;
        min-width: auto;
        max-width: none;
        width: 100%;
        justify-content: space-between;
        padding: 12px 16px;
        margin-bottom: 12px;
        box-sizing: border-box;
        min-height: auto;

        .avator {
          width: 32px;
          height: 32px;
          margin-bottom: 0;
        }

        .nick {
          flex: 1;
          // margin-left: 12px;
        }

        .operate-btn {
          margin-top: 0;
          width: auto;
          padding: 6px 12px;
        }
      }

      .main {
        width: 100%;

        .top-notice{
          .noticeWrap{
            flex-direction: column;
            align-items: flex-start;
            gap: 4px;
            .iden-number{
              margin: 0;
            }
          }
        }
        ::v-deep .el-tag{
          padding: 6px 12px;
        }

        .main-top {
          .top-one {
            padding: 16px;

            .one-left {
              .boldTitle {
                font-size: 16px;
              }

              .ft12 {
                font-size: 10px;
              }
            }

            .one-right {
              flex-direction: column;
              gap: 8px;

              .unit-r {
                width: fit-content;
                max-width: 100%;
                text-align: center;
              }
            }
          }
        }


        .main-list {
          padding: 0 12px;

          .list-item {
            padding: 12px 0;

            .item-left {
              .boldTitle {
                font-size: 14px;
                margin-bottom: 8px;
              }
            }

            .item-right {
              .right-top {
                flex-wrap: wrap;
                gap: 6px;

                .timeInfo {
                  font-size: 11px;
                  padding: 2px 8px;
                }
              }
              .imgType{
                justify-content: flex-end;
              }

              .right-bottom {
                .downLoad {
                  justify-content: center;
                  width: 100%;
                }
              }
            }

            .bidStatusWin,
            .bidStatusWait,
            .bidStatusCur,
            .bidStatusNot {
              font-size: 10px;
              padding: 6px 10px;

              img {
                width: 14px;
                height: 14px;
              }
            }
          }
        }
        .success-top{
          // padding: 0 20px 12px;
        }
      }
    }
  }
  .normalUpload,.allowUploadBox{
    p{
      text-align: left;
      padding: 0 6px;
      box-sizing: border-box;
    }
  }

  // 弹窗移动端适配
  ::v-deep .el-dialog {
    width: 90% !important;
    margin: 0 auto !important;

    .el-dialog__header {
      padding: 16px;

      .title {
        p {
          font-size: 12px;
        }
      }
    }

    .el-dialog__body {
      padding: 16px;

      .content {
        .useTimes {
          padding: 4px 12px;

          .left {
            font-size: 12px;
          }
        }
      }
    }

    .el-dialog__footer {
      padding: 16px;

      .dialog-footer {
        display: flex;
        gap: 12px;

        .el-button {
          flex: 1;
        }
      }
    }
  }
  .group-item .group-title {
    .error{
      text-align: left;
      margin-top: 4px;
    }
  }
}

// 超小屏幕
@media screen and (max-width: 480px) {
  .quotationWrap {
    padding: 0;
    .header {
      .header-left {
        flex-direction: row;
        width: 100%;
        text-align: center;
        padding: 0 12px;
        box-sizing: border-box;
        // justify-content: center;
        .LogoName {
          font-size: 16px;
        }
      }
      .header-right {
        margin: 0 auto;
        p {
          font-size: 11px;

          span {
            font-size: 18px;
          }
        }
      }
    }

    .contentBox {
      .userWrap {
        justify-content: flex-start;
        flex-direction: column;
        gap: 12px;
        .nick{

        }
      }
      .listItemImgType{
        // margin-right: 12px;
      }
      .main {

        .main-top {
          // position: sticky;
          // top: 0;
          .top-one {
            .one-left {
              .boldTitle {
                font-size: 14px;
              }
            }
            .one-right {
              .main-input {
                flex: 1;
                ::v-deep input {
                  font-size: 20px;
                }
              }
            }
          }
        }
        .success-top{
          .successTitle{
            flex-direction: column;
            align-items: flex-start;
            gap: 6px;
            margin-bottom: 12px;
          }
          .btn{
            margin-top: 0;
            min-width: 110px;
          }
        }

        .main-list {
          .list-item {
            .item-right {
              .right-bottom {
                flex-direction: column;
                gap: 8px;
                align-items: flex-end;
                .cancelBtn{
                  min-width: 75px;
                  max-width: 75px;
                }
                .downLoad{
                  width: auto;
                }
                p {
                  margin-bottom: 0;
                  font-size: 11px;
                  width: 100%;
                  text-align: right;
                }
                .btn {
                  font-size: 11px;
                  padding: 6px 10px;
                }
              }
            }
          }
          .list-item1 {
            .item-left{
              max-width: 100%;
            }
          }

        }
      }
    }
    .time_out_box .timeInfo{
      margin-left: 4px;
    }
    .theme-switch-card {
      display: flex;
      gap: 12px;
      padding: 0 12px;
      .theme-item {
        flex: 1;
        margin-bottom: 0;

        .theme-content {
          min-height: 39px;
          border-radius: 16px;
          font-size: 14px;
          font-weight: 600;
        }

        .badge {
          top: -8px;
          right: -6px;

          // width: 24px;
          // height: 24px;

          font-size: 12px;
          font-weight: 500;
        }

        .arrow {
          left: 50%;
          top: auto;
          bottom: -11px;

          transform: translateX(-50%);

          border-left: 12px solid transparent;
          border-right: 12px solid transparent;
          border-top: 12px solid var(--primary-hover);
          border-bottom: none;
        }

        &.active {
          .theme-content {
            background: var(--primary-gradient);
            color: #fff;
          }
        }
      }
    }
  }
  .theme-purple .listItemImgType{
    width: 60px;
  }
  .theme-green .listItemImgType{
    width: 70px;
  }
  .uploadAndTimeDialog{
    .example-card{
      display: flex;
      flex-direction: column;
      padding: 12px 11px;
      .top{
        display: flex;
        flex-direction: column;
        font-size: 12px;
        gap: 12px;
        .left{
          display: flex;
          width: 100%;
          justify-content: space-between;
          .desc{
            font-size: 12px;
            margin-top: 0;
          }
        }
        .right{
          width: 100%;
          justify-content: space-between;
          .enlarge{
            font-size: 12px;
          }
        }
      }
      .tip{
        font-size: 12px;
        align-items: center;
        .icon{
          width: 12px;
          height: 12px;
        }
      }
    }
    .hasReport{
      font-size: 12px;
      span{
        // height: 35px;
      }
    }
    .fileNameTop{
      width: 100%;
    }
    .fileLabel{
      white-space: nowrap;
      overflow: hidden;
      flex: 1;
      text-overflow: ellipsis;
    }
    .moreTime_content{
      .desc{
        font-size: 12px;
        margin-bottom: 12px;
      }
    }
    .dialog-footer {
      display: flex;
      gap: 12px;

      .el-button {
        flex: 1;
      }
    }
    .fileListWrap{
      .fileInfo{
        width: calc(100% - 20px);
      }
      .boldTitle{
        font-size: 12px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .group-item{
      font-size: 12px;
      .group-header{

      }
      .group-warning{
        text-align: left;
      }
      .normalTitle{

      }
    }
  }

  
}

::v-deep .el-tag{
  height: auto;
  min-height: 28px;
  padding: 6px 20px;
  line-height: 12px;
  box-sizing: border-box;
  white-space: normal;
  max-width: 100%;
}
::v-deep .el-tag.el-tag--danger{
  background: #FFE3E3;
  color: #F0351C;
}
</style>
